/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Coach Contract Management API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptTermSheetCounterBody,
  ActivityItem,
  AddClauseVersionBody,
  AddContractClauseBody,
  AdminCoachDetail,
  AdminCoachListResponse,
  AdminContractDetail,
  AdminDemoInvitation,
  AdminDemoInvitationCreateRequest,
  AdminFeatureFlag,
  AdminFeatureFlagBody,
  AdminFeatureFlagList,
  AdminHealth,
  AdminImpersonateBody,
  AdminImpersonationStatus,
  AdminInsightsAtRisk,
  AdminInsightsDeliverability,
  AdminInsightsLifecycle,
  AdminInsightsRevenue,
  AdminInsightsTrials,
  AdminPersonasBody,
  AdminPersonasResponse,
  AdminSeatCapBody,
  AdminSeatCapResponse,
  AnalyticsBuyoutSeries,
  AnalyticsKpis,
  AnalyticsPreset,
  AuditLogEntry,
  BackfillContractCompensation200,
  BulkConfirmCompensation200,
  BuyoutBreakdown,
  CalculateBuyoutBody,
  Clause,
  ClauseDetail,
  ClauseUnlockRequest,
  ClauseUnlockRequestInboxItem,
  ClauseUnlockRequestPendingCount,
  ClauseVersion,
  Coach,
  CoachDetail,
  Comment,
  CommitmentSeriesItem,
  CompensationBackfillAllResponse,
  CompensationCoverageResponse,
  CompensationNeedsReviewResponse,
  ComplianceResult,
  Contract,
  ContractClause,
  ContractClauseOverride,
  ContractCompensation,
  ContractDeliveryAlertsMuteState,
  ContractDocument,
  ContractListItem,
  ContractTemplate,
  ContractTimelineItem,
  CreateAnalyticsPresetBody,
  CreateClauseBody,
  CreateCoachBody,
  CreateCommentBody,
  CreateContractBody,
  CreateContractDocumentBody,
  CreateContractTemplateBody,
  CreateCustomFieldDefinitionBody,
  CreateInsurancePolicyBody,
  CreateMitigationBody,
  CreateNegotiationItemBody,
  CreatePolicyRuleBody,
  CustomFieldDefinition,
  CustomFieldEntityValue,
  DashboardSummary,
  DemoInviteRedeemRequest,
  DemoInviteRedeemResponse,
  DismissClauseSuggestionBody,
  EquityComparablePair,
  EquityProportionality,
  EquitySummary,
  EquityTrendPoint,
  ErrorResponse,
  ExpiringSoonBuckets,
  GetAnalyticsKpisParams,
  GetBuyoutSeriesParams,
  GetCommitmentSeriesParams,
  GetEquityComparablePairsParams,
  GetEquityProportionalityParams,
  GetEquitySummaryParams,
  GetEquityTrendParams,
  GetExpiringSoonParams,
  GetSpendByDimensionParams,
  GlobalSearchParams,
  HealthStatus,
  InstantiateContractTemplateBody,
  InstantiateContractTemplateResponse,
  InsuranceCoachSummary,
  InsurancePolicy,
  LifecycleTransitionResult,
  ListAuditLogParams,
  ListClauseUnlockRequestsParams,
  ListClausesParams,
  ListCoachesParams,
  ListCommentsParams,
  ListCompensationNeedsReviewParams,
  ListContractTemplatesParams,
  ListContractsParams,
  ListCustomFieldDefinitionsParams,
  ListCustomFieldValuesParams,
  ListInsurancePoliciesParams,
  ListMitigationsParams,
  ListMyMentionsParams,
  ListNotificationsParams,
  ListParticipationCountsParams,
  ListRenewalsParams,
  LockContractClauseOverrideBody,
  LockDocumentBody,
  LockDocumentResult,
  LogCounterBody,
  LogCounterResult,
  MarkAllNotificationsRead200,
  MarkMentionsReadBody,
  MarkMentionsReadResponse,
  MentionItem,
  MergeField,
  Mitigation,
  NegotiationItem,
  NegotiationRound,
  NotificationItem,
  NotificationPage,
  NotificationPreferenceItem,
  NotificationUnreadCount,
  OrgFiscalYearResponse,
  ParticipationCount,
  PolicyRule,
  PolicySuggestionDismissal,
  PromoteContractClauseOverrideBody,
  PromoteContractClauseOverrideResponse,
  ProposeContractClauseAlternateBody,
  RecordTermSheetCounterBody,
  Renewal,
  ReorderContractClauses200,
  ReorderContractClausesBody,
  RequestLegalReviewResult,
  RequestUploadUrlBody,
  RequestUploadUrlResponse,
  ResolveClauseUnlockRequestBody,
  SearchResults,
  SendExternalBody,
  SendExternalConflict,
  SendExternalResult,
  SetContractDeliveryAlertsMuteBody,
  SpendByDimensionRow,
  StartRenewalBody,
  TeamMember,
  TermSheetVersion,
  TransitionLifecycleBody,
  UpdateClauseBody,
  UpdateCoachBody,
  UpdateCommentBody,
  UpdateContractBody,
  UpdateContractCompensationBody,
  UpdateContractTemplateBody,
  UpdateCustomFieldDefinitionBody,
  UpdateInsurancePolicyBody,
  UpdateMemberPersonasBody,
  UpdateMemberPersonasResponse,
  UpdateMitigationBody,
  UpdateNegotiationItemBody,
  UpdateNotificationPreferencesBody,
  UpdateOrgFiscalYearBody,
  UpdatePolicyRuleBody,
  UpdateRenewalBody,
  UpdateTermSheetStatusBody,
  UpsertContractClauseOverrideBody,
  UpsertCustomFieldValues200,
  UpsertCustomFieldValuesBody,
  UpsertParticipationCountBody,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List notifications for the current user (paginated)
 */
export const getListNotificationsUrl = (params?: ListNotificationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/notifications?${stringifiedParams}`
    : `/api/notifications`;
};

export const listNotifications = async (
  params?: ListNotificationsParams,
  options?: RequestInit,
): Promise<NotificationPage> => {
  return customFetch<NotificationPage>(getListNotificationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListNotificationsQueryKey = (
  params?: ListNotificationsParams,
) => {
  return [`/api/notifications`, ...(params ? [params] : [])] as const;
};

export const getListNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListNotificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNotifications>>
  > = ({ signal }) => listNotifications(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsQueryError = ErrorType<unknown>;

/**
 * @summary List notifications for the current user (paginated)
 */

export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get unread notification count for the current user
 */
export const getGetNotificationUnreadCountUrl = () => {
  return `/api/notifications/unread-count`;
};

export const getNotificationUnreadCount = async (
  options?: RequestInit,
): Promise<NotificationUnreadCount> => {
  return customFetch<NotificationUnreadCount>(
    getGetNotificationUnreadCountUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNotificationUnreadCountQueryKey = () => {
  return [`/api/notifications/unread-count`] as const;
};

export const getGetNotificationUnreadCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationUnreadCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationUnreadCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>
  > = ({ signal }) => getNotificationUnreadCount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationUnreadCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationUnreadCount>>
>;
export type GetNotificationUnreadCountQueryError = ErrorType<unknown>;

/**
 * @summary Get unread notification count for the current user
 */

export function useGetNotificationUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationUnreadCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationUnreadCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark all notifications as read for the current user
 */
export const getMarkAllNotificationsReadUrl = () => {
  return `/api/notifications/mark-all-read`;
};

export const markAllNotificationsRead = async (
  options?: RequestInit,
): Promise<MarkAllNotificationsRead200> => {
  return customFetch<MarkAllNotificationsRead200>(
    getMarkAllNotificationsReadUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMarkAllNotificationsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["markAllNotificationsRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    void
  > = () => {
    return markAllNotificationsRead(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllNotificationsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllNotificationsRead>>
>;

export type MarkAllNotificationsReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark all notifications as read for the current user
 */
export const useMarkAllNotificationsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markAllNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getMarkAllNotificationsReadMutationOptions(options));
};

/**
 * @summary Mark a single notification as read
 */
export const getMarkNotificationReadUrl = (id: number) => {
  return `/api/notifications/${id}/read`;
};

export const markNotificationRead = async (
  id: number,
  options?: RequestInit,
): Promise<NotificationItem> => {
  return customFetch<NotificationItem>(getMarkNotificationReadUrl(id), {
    ...options,
    method: "PATCH",
  });
};

export const getMarkNotificationReadMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["markNotificationRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationRead>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return markNotificationRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationRead>>
>;

export type MarkNotificationReadMutationError = ErrorType<void>;

/**
 * @summary Mark a single notification as read
 */
export const useMarkNotificationRead = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationRead>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getMarkNotificationReadMutationOptions(options));
};

/**
 * @summary Get notification preferences for the current user
 */
export const getGetNotificationPreferencesUrl = () => {
  return `/api/notifications/preferences`;
};

export const getNotificationPreferences = async (
  options?: RequestInit,
): Promise<NotificationPreferenceItem[]> => {
  return customFetch<NotificationPreferenceItem[]>(
    getGetNotificationPreferencesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNotificationPreferencesQueryKey = () => {
  return [`/api/notifications/preferences`] as const;
};

export const getGetNotificationPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationPreferences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationPreferences>>
  > = ({ signal }) => getNotificationPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationPreferences>>
>;
export type GetNotificationPreferencesQueryError = ErrorType<unknown>;

/**
 * @summary Get notification preferences for the current user
 */

export function useGetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getNotificationPreferences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update notification preferences
 */
export const getUpdateNotificationPreferencesUrl = () => {
  return `/api/notifications/preferences`;
};

export const updateNotificationPreferences = async (
  updateNotificationPreferencesBody: UpdateNotificationPreferencesBody,
  options?: RequestInit,
): Promise<NotificationPreferenceItem[]> => {
  return customFetch<NotificationPreferenceItem[]>(
    getUpdateNotificationPreferencesUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateNotificationPreferencesBody),
    },
  );
};

export const getUpdateNotificationPreferencesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    TError,
    { data: BodyType<UpdateNotificationPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationPreferences>>,
  TError,
  { data: BodyType<UpdateNotificationPreferencesBody> },
  TContext
> => {
  const mutationKey = ["updateNotificationPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    { data: BodyType<UpdateNotificationPreferencesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateNotificationPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationPreferences>>
>;
export type UpdateNotificationPreferencesMutationBody =
  BodyType<UpdateNotificationPreferencesBody>;
export type UpdateNotificationPreferencesMutationError = ErrorType<unknown>;

/**
 * @summary Update notification preferences
 */
export const useUpdateNotificationPreferences = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    TError,
    { data: BodyType<UpdateNotificationPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationPreferences>>,
  TError,
  { data: BodyType<UpdateNotificationPreferencesBody> },
  TContext
> => {
  return useMutation(getUpdateNotificationPreferencesMutationOptions(options));
};

/**
 * @summary Get headline KPI metrics for the analytics dashboard
 */
export const getGetAnalyticsKpisUrl = (params?: GetAnalyticsKpisParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/kpis?${stringifiedParams}`
    : `/api/analytics/kpis`;
};

export const getAnalyticsKpis = async (
  params?: GetAnalyticsKpisParams,
  options?: RequestInit,
): Promise<AnalyticsKpis> => {
  return customFetch<AnalyticsKpis>(getGetAnalyticsKpisUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAnalyticsKpisQueryKey = (
  params?: GetAnalyticsKpisParams,
) => {
  return [`/api/analytics/kpis`, ...(params ? [params] : [])] as const;
};

export const getGetAnalyticsKpisQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsKpis>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAnalyticsKpisParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsKpis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnalyticsKpisQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsKpis>>
  > = ({ signal }) => getAnalyticsKpis(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsKpis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsKpisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsKpis>>
>;
export type GetAnalyticsKpisQueryError = ErrorType<unknown>;

/**
 * @summary Get headline KPI metrics for the analytics dashboard
 */

export function useGetAnalyticsKpis<
  TData = Awaited<ReturnType<typeof getAnalyticsKpis>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAnalyticsKpisParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsKpis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsKpisQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Multi-year guaranteed comp commitment series for the stacked bar chart
 */
export const getGetCommitmentSeriesUrl = (
  params?: GetCommitmentSeriesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/commitment-series?${stringifiedParams}`
    : `/api/analytics/commitment-series`;
};

export const getCommitmentSeries = async (
  params?: GetCommitmentSeriesParams,
  options?: RequestInit,
): Promise<CommitmentSeriesItem[]> => {
  return customFetch<CommitmentSeriesItem[]>(
    getGetCommitmentSeriesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCommitmentSeriesQueryKey = (
  params?: GetCommitmentSeriesParams,
) => {
  return [
    `/api/analytics/commitment-series`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCommitmentSeriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommitmentSeries>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCommitmentSeriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCommitmentSeries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCommitmentSeriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCommitmentSeries>>
  > = ({ signal }) =>
    getCommitmentSeries(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommitmentSeries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCommitmentSeriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommitmentSeries>>
>;
export type GetCommitmentSeriesQueryError = ErrorType<unknown>;

/**
 * @summary Multi-year guaranteed comp commitment series for the stacked bar chart
 */

export function useGetCommitmentSeries<
  TData = Awaited<ReturnType<typeof getCommitmentSeries>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCommitmentSeriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCommitmentSeries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCommitmentSeriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Buyout exposure series over the next 60 months plus top-10 individual buyout exposures
 */
export const getGetBuyoutSeriesUrl = (params?: GetBuyoutSeriesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/buyout-series?${stringifiedParams}`
    : `/api/analytics/buyout-series`;
};

export const getBuyoutSeries = async (
  params?: GetBuyoutSeriesParams,
  options?: RequestInit,
): Promise<AnalyticsBuyoutSeries> => {
  return customFetch<AnalyticsBuyoutSeries>(getGetBuyoutSeriesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetBuyoutSeriesQueryKey = (params?: GetBuyoutSeriesParams) => {
  return [`/api/analytics/buyout-series`, ...(params ? [params] : [])] as const;
};

export const getGetBuyoutSeriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBuyoutSeries>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBuyoutSeriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBuyoutSeries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBuyoutSeriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuyoutSeries>>> = ({
    signal,
  }) => getBuyoutSeries(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBuyoutSeries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBuyoutSeriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBuyoutSeries>>
>;
export type GetBuyoutSeriesQueryError = ErrorType<unknown>;

/**
 * @summary Buyout exposure series over the next 60 months plus top-10 individual buyout exposures
 */

export function useGetBuyoutSeries<
  TData = Awaited<ReturnType<typeof getBuyoutSeries>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBuyoutSeriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBuyoutSeries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBuyoutSeriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Spend breakdown table by sport, role, or conference
 */
export const getGetSpendByDimensionUrl = (
  params?: GetSpendByDimensionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/spend-by-dimension?${stringifiedParams}`
    : `/api/analytics/spend-by-dimension`;
};

export const getSpendByDimension = async (
  params?: GetSpendByDimensionParams,
  options?: RequestInit,
): Promise<SpendByDimensionRow[]> => {
  return customFetch<SpendByDimensionRow[]>(getGetSpendByDimensionUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetSpendByDimensionQueryKey = (
  params?: GetSpendByDimensionParams,
) => {
  return [
    `/api/analytics/spend-by-dimension`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSpendByDimensionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSpendByDimension>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSpendByDimensionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpendByDimension>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSpendByDimensionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSpendByDimension>>
  > = ({ signal }) =>
    getSpendByDimension(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSpendByDimension>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSpendByDimensionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSpendByDimension>>
>;
export type GetSpendByDimensionQueryError = ErrorType<unknown>;

/**
 * @summary Spend breakdown table by sport, role, or conference
 */

export function useGetSpendByDimension<
  TData = Awaited<ReturnType<typeof getSpendByDimension>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSpendByDimensionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpendByDimension>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSpendByDimensionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Dollar value of contracts expiring in the next 90, 180, and 365 days
 */
export const getGetExpiringSoonUrl = (params?: GetExpiringSoonParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/expiring-soon?${stringifiedParams}`
    : `/api/analytics/expiring-soon`;
};

export const getExpiringSoon = async (
  params?: GetExpiringSoonParams,
  options?: RequestInit,
): Promise<ExpiringSoonBuckets> => {
  return customFetch<ExpiringSoonBuckets>(getGetExpiringSoonUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetExpiringSoonQueryKey = (params?: GetExpiringSoonParams) => {
  return [`/api/analytics/expiring-soon`, ...(params ? [params] : [])] as const;
};

export const getGetExpiringSoonQueryOptions = <
  TData = Awaited<ReturnType<typeof getExpiringSoon>>,
  TError = ErrorType<unknown>,
>(
  params?: GetExpiringSoonParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExpiringSoon>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExpiringSoonQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpiringSoon>>> = ({
    signal,
  }) => getExpiringSoon(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getExpiringSoon>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetExpiringSoonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExpiringSoon>>
>;
export type GetExpiringSoonQueryError = ErrorType<unknown>;

/**
 * @summary Dollar value of contracts expiring in the next 90, 180, and 365 days
 */

export function useGetExpiringSoon<
  TData = Awaited<ReturnType<typeof getExpiringSoon>>,
  TError = ErrorType<unknown>,
>(
  params?: GetExpiringSoonParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExpiringSoon>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetExpiringSoonQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Org admins receive every preset for their org. Non-admin members
(e.g. Finance persona) receive only presets they created themselves.

 * @summary List analytics filter presets visible to the current user
 */
export const getListAnalyticsPresetsUrl = () => {
  return `/api/analytics/presets`;
};

export const listAnalyticsPresets = async (
  options?: RequestInit,
): Promise<AnalyticsPreset[]> => {
  return customFetch<AnalyticsPreset[]>(getListAnalyticsPresetsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAnalyticsPresetsQueryKey = () => {
  return [`/api/analytics/presets`] as const;
};

export const getListAnalyticsPresetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAnalyticsPresets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAnalyticsPresets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAnalyticsPresetsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAnalyticsPresets>>
  > = ({ signal }) => listAnalyticsPresets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAnalyticsPresets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAnalyticsPresetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAnalyticsPresets>>
>;
export type ListAnalyticsPresetsQueryError = ErrorType<unknown>;

/**
 * @summary List analytics filter presets visible to the current user
 */

export function useListAnalyticsPresets<
  TData = Awaited<ReturnType<typeof listAnalyticsPresets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAnalyticsPresets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAnalyticsPresetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save the current analytics filter state as a named preset
 */
export const getCreateAnalyticsPresetUrl = () => {
  return `/api/analytics/presets`;
};

export const createAnalyticsPreset = async (
  createAnalyticsPresetBody: CreateAnalyticsPresetBody,
  options?: RequestInit,
): Promise<AnalyticsPreset> => {
  return customFetch<AnalyticsPreset>(getCreateAnalyticsPresetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAnalyticsPresetBody),
  });
};

export const getCreateAnalyticsPresetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAnalyticsPreset>>,
    TError,
    { data: BodyType<CreateAnalyticsPresetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAnalyticsPreset>>,
  TError,
  { data: BodyType<CreateAnalyticsPresetBody> },
  TContext
> => {
  const mutationKey = ["createAnalyticsPreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAnalyticsPreset>>,
    { data: BodyType<CreateAnalyticsPresetBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAnalyticsPreset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAnalyticsPresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAnalyticsPreset>>
>;
export type CreateAnalyticsPresetMutationBody =
  BodyType<CreateAnalyticsPresetBody>;
export type CreateAnalyticsPresetMutationError = ErrorType<void>;

/**
 * @summary Save the current analytics filter state as a named preset
 */
export const useCreateAnalyticsPreset = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAnalyticsPreset>>,
    TError,
    { data: BodyType<CreateAnalyticsPresetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAnalyticsPreset>>,
  TError,
  { data: BodyType<CreateAnalyticsPresetBody> },
  TContext
> => {
  return useMutation(getCreateAnalyticsPresetMutationOptions(options));
};

/**
 * Admins can delete any preset in their org. Non-admin members can
only delete presets they created themselves.

 * @summary Delete a saved analytics preset
 */
export const getDeleteAnalyticsPresetUrl = (id: number) => {
  return `/api/analytics/presets/${id}`;
};

export const deleteAnalyticsPreset = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteAnalyticsPresetUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAnalyticsPresetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAnalyticsPreset>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAnalyticsPreset>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAnalyticsPreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAnalyticsPreset>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAnalyticsPreset(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAnalyticsPresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAnalyticsPreset>>
>;

export type DeleteAnalyticsPresetMutationError = ErrorType<void>;

/**
 * @summary Delete a saved analytics preset
 */
export const useDeleteAnalyticsPreset = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAnalyticsPreset>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAnalyticsPreset>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAnalyticsPresetMutationOptions(options));
};

/**
 * @summary Title IX-style equity summary by program gender
 */
export const getGetEquitySummaryUrl = (params?: GetEquitySummaryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/equity/summary?${stringifiedParams}`
    : `/api/analytics/equity/summary`;
};

export const getEquitySummary = async (
  params?: GetEquitySummaryParams,
  options?: RequestInit,
): Promise<EquitySummary> => {
  return customFetch<EquitySummary>(getGetEquitySummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetEquitySummaryQueryKey = (
  params?: GetEquitySummaryParams,
) => {
  return [
    `/api/analytics/equity/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEquitySummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getEquitySummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEquitySummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEquitySummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEquitySummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEquitySummary>>
  > = ({ signal }) => getEquitySummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEquitySummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEquitySummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEquitySummary>>
>;
export type GetEquitySummaryQueryError = ErrorType<unknown>;

/**
 * @summary Title IX-style equity summary by program gender
 */

export function useGetEquitySummary<
  TData = Awaited<ReturnType<typeof getEquitySummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEquitySummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEquitySummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEquitySummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Side-by-side comparable men's/women's sport pairs
 */
export const getGetEquityComparablePairsUrl = (
  params?: GetEquityComparablePairsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/equity/comparable-pairs?${stringifiedParams}`
    : `/api/analytics/equity/comparable-pairs`;
};

export const getEquityComparablePairs = async (
  params?: GetEquityComparablePairsParams,
  options?: RequestInit,
): Promise<EquityComparablePair[]> => {
  return customFetch<EquityComparablePair[]>(
    getGetEquityComparablePairsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetEquityComparablePairsQueryKey = (
  params?: GetEquityComparablePairsParams,
) => {
  return [
    `/api/analytics/equity/comparable-pairs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEquityComparablePairsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEquityComparablePairs>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEquityComparablePairsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEquityComparablePairs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEquityComparablePairsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEquityComparablePairs>>
  > = ({ signal }) =>
    getEquityComparablePairs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEquityComparablePairs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEquityComparablePairsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEquityComparablePairs>>
>;
export type GetEquityComparablePairsQueryError = ErrorType<unknown>;

/**
 * @summary Side-by-side comparable men's/women's sport pairs
 */

export function useGetEquityComparablePairs<
  TData = Awaited<ReturnType<typeof getEquityComparablePairs>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEquityComparablePairsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEquityComparablePairs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEquityComparablePairsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Multi-year men's vs women's spend ratio trend
 */
export const getGetEquityTrendUrl = (params?: GetEquityTrendParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/equity/trend?${stringifiedParams}`
    : `/api/analytics/equity/trend`;
};

export const getEquityTrend = async (
  params?: GetEquityTrendParams,
  options?: RequestInit,
): Promise<EquityTrendPoint[]> => {
  return customFetch<EquityTrendPoint[]>(getGetEquityTrendUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetEquityTrendQueryKey = (params?: GetEquityTrendParams) => {
  return [`/api/analytics/equity/trend`, ...(params ? [params] : [])] as const;
};

export const getGetEquityTrendQueryOptions = <
  TData = Awaited<ReturnType<typeof getEquityTrend>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEquityTrendParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEquityTrend>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEquityTrendQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquityTrend>>> = ({
    signal,
  }) => getEquityTrend(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEquityTrend>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEquityTrendQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEquityTrend>>
>;
export type GetEquityTrendQueryError = ErrorType<unknown>;

/**
 * @summary Multi-year men's vs women's spend ratio trend
 */

export function useGetEquityTrend<
  TData = Awaited<ReturnType<typeof getEquityTrend>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEquityTrendParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEquityTrend>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEquityTrendQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Spend ratio vs participation ratio (Title IX core test)
 */
export const getGetEquityProportionalityUrl = (
  params?: GetEquityProportionalityParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/equity/proportionality?${stringifiedParams}`
    : `/api/analytics/equity/proportionality`;
};

export const getEquityProportionality = async (
  params?: GetEquityProportionalityParams,
  options?: RequestInit,
): Promise<EquityProportionality> => {
  return customFetch<EquityProportionality>(
    getGetEquityProportionalityUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetEquityProportionalityQueryKey = (
  params?: GetEquityProportionalityParams,
) => {
  return [
    `/api/analytics/equity/proportionality`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEquityProportionalityQueryOptions = <
  TData = Awaited<ReturnType<typeof getEquityProportionality>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEquityProportionalityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEquityProportionality>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEquityProportionalityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEquityProportionality>>
  > = ({ signal }) =>
    getEquityProportionality(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEquityProportionality>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEquityProportionalityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEquityProportionality>>
>;
export type GetEquityProportionalityQueryError = ErrorType<unknown>;

/**
 * @summary Spend ratio vs participation ratio (Title IX core test)
 */

export function useGetEquityProportionality<
  TData = Awaited<ReturnType<typeof getEquityProportionality>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEquityProportionalityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEquityProportionality>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEquityProportionalityQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List participation (athlete) counts for the org
 */
export const getListParticipationCountsUrl = (
  params?: ListParticipationCountsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/participation-counts?${stringifiedParams}`
    : `/api/participation-counts`;
};

export const listParticipationCounts = async (
  params?: ListParticipationCountsParams,
  options?: RequestInit,
): Promise<ParticipationCount[]> => {
  return customFetch<ParticipationCount[]>(
    getListParticipationCountsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListParticipationCountsQueryKey = (
  params?: ListParticipationCountsParams,
) => {
  return [`/api/participation-counts`, ...(params ? [params] : [])] as const;
};

export const getListParticipationCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof listParticipationCounts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListParticipationCountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listParticipationCounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListParticipationCountsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listParticipationCounts>>
  > = ({ signal }) =>
    listParticipationCounts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listParticipationCounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListParticipationCountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listParticipationCounts>>
>;
export type ListParticipationCountsQueryError = ErrorType<unknown>;

/**
 * @summary List participation (athlete) counts for the org
 */

export function useListParticipationCounts<
  TData = Awaited<ReturnType<typeof listParticipationCounts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListParticipationCountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listParticipationCounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListParticipationCountsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or update a participation count for (sport, gender, year)
 */
export const getUpsertParticipationCountUrl = () => {
  return `/api/participation-counts`;
};

export const upsertParticipationCount = async (
  upsertParticipationCountBody: UpsertParticipationCountBody,
  options?: RequestInit,
): Promise<ParticipationCount> => {
  return customFetch<ParticipationCount>(getUpsertParticipationCountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(upsertParticipationCountBody),
  });
};

export const getUpsertParticipationCountMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertParticipationCount>>,
    TError,
    { data: BodyType<UpsertParticipationCountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertParticipationCount>>,
  TError,
  { data: BodyType<UpsertParticipationCountBody> },
  TContext
> => {
  const mutationKey = ["upsertParticipationCount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertParticipationCount>>,
    { data: BodyType<UpsertParticipationCountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return upsertParticipationCount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertParticipationCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertParticipationCount>>
>;
export type UpsertParticipationCountMutationBody =
  BodyType<UpsertParticipationCountBody>;
export type UpsertParticipationCountMutationError = ErrorType<void>;

/**
 * @summary Create or update a participation count for (sport, gender, year)
 */
export const useUpsertParticipationCount = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertParticipationCount>>,
    TError,
    { data: BodyType<UpsertParticipationCountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertParticipationCount>>,
  TError,
  { data: BodyType<UpsertParticipationCountBody> },
  TContext
> => {
  return useMutation(getUpsertParticipationCountMutationOptions(options));
};

/**
 * @summary Delete a participation count row
 */
export const getDeleteParticipationCountUrl = (id: number) => {
  return `/api/participation-counts/${id}`;
};

export const deleteParticipationCount = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteParticipationCountUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteParticipationCountMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteParticipationCount>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteParticipationCount>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteParticipationCount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteParticipationCount>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteParticipationCount(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteParticipationCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteParticipationCount>>
>;

export type DeleteParticipationCountMutationError = ErrorType<void>;

/**
 * @summary Delete a participation count row
 */
export const useDeleteParticipationCount = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteParticipationCount>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteParticipationCount>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteParticipationCountMutationOptions(options));
};

/**
 * @summary Search coaches, contracts, and mitigations within the current org
 */
export const getGlobalSearchUrl = (params: GlobalSearchParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/search?${stringifiedParams}`
    : `/api/search`;
};

export const globalSearch = async (
  params: GlobalSearchParams,
  options?: RequestInit,
): Promise<SearchResults> => {
  return customFetch<SearchResults>(getGlobalSearchUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGlobalSearchQueryKey = (params?: GlobalSearchParams) => {
  return [`/api/search`, ...(params ? [params] : [])] as const;
};

export const getGlobalSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof globalSearch>>,
  TError = ErrorType<unknown>,
>(
  params: GlobalSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof globalSearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalSearch>>> = ({
    signal,
  }) => globalSearch(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalSearch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof globalSearch>>
>;
export type GlobalSearchQueryError = ErrorType<unknown>;

/**
 * @summary Search coaches, contracts, and mitigations within the current org
 */

export function useGlobalSearch<
  TData = Awaited<ReturnType<typeof globalSearch>>,
  TError = ErrorType<unknown>,
>(
  params: GlobalSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof globalSearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get dashboard metrics summary
 */
export const getGetDashboardSummaryUrl = () => {
  return `/api/dashboard/summary`;
};

export const getDashboardSummary = async (
  options?: RequestInit,
): Promise<DashboardSummary> => {
  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardSummaryQueryKey = () => {
  return [`/api/dashboard/summary`] as const;
};

export const getGetDashboardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardSummary>>
  > = ({ signal }) => getDashboardSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardSummary>>
>;
export type GetDashboardSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get dashboard metrics summary
 */

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get recent activity feed
 */
export const getGetDashboardActivityUrl = () => {
  return `/api/dashboard/activity`;
};

export const getDashboardActivity = async (
  options?: RequestInit,
): Promise<ActivityItem[]> => {
  return customFetch<ActivityItem[]>(getGetDashboardActivityUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardActivityQueryKey = () => {
  return [`/api/dashboard/activity`] as const;
};

export const getGetDashboardActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardActivity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardActivity>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardActivityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardActivity>>
  > = ({ signal }) => getDashboardActivity({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardActivity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardActivity>>
>;
export type GetDashboardActivityQueryError = ErrorType<unknown>;

/**
 * @summary Get recent activity feed
 */

export function useGetDashboardActivity<
  TData = Awaited<ReturnType<typeof getDashboardActivity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardActivity>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardActivityQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all coaches
 */
export const getListCoachesUrl = (params?: ListCoachesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/coaches?${stringifiedParams}`
    : `/api/coaches`;
};

export const listCoaches = async (
  params?: ListCoachesParams,
  options?: RequestInit,
): Promise<Coach[]> => {
  return customFetch<Coach[]>(getListCoachesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCoachesQueryKey = (params?: ListCoachesParams) => {
  return [`/api/coaches`, ...(params ? [params] : [])] as const;
};

export const getListCoachesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCoaches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCoachesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCoaches>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCoachesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoaches>>> = ({
    signal,
  }) => listCoaches(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCoaches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCoachesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCoaches>>
>;
export type ListCoachesQueryError = ErrorType<unknown>;

/**
 * @summary List all coaches
 */

export function useListCoaches<
  TData = Awaited<ReturnType<typeof listCoaches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCoachesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCoaches>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCoachesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new coach
 */
export const getCreateCoachUrl = () => {
  return `/api/coaches`;
};

export const createCoach = async (
  createCoachBody: CreateCoachBody,
  options?: RequestInit,
): Promise<Coach> => {
  return customFetch<Coach>(getCreateCoachUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCoachBody),
  });
};

export const getCreateCoachMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoach>>,
    TError,
    { data: BodyType<CreateCoachBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCoach>>,
  TError,
  { data: BodyType<CreateCoachBody> },
  TContext
> => {
  const mutationKey = ["createCoach"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCoach>>,
    { data: BodyType<CreateCoachBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCoach(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCoachMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCoach>>
>;
export type CreateCoachMutationBody = BodyType<CreateCoachBody>;
export type CreateCoachMutationError = ErrorType<unknown>;

/**
 * @summary Create a new coach
 */
export const useCreateCoach = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoach>>,
    TError,
    { data: BodyType<CreateCoachBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCoach>>,
  TError,
  { data: BodyType<CreateCoachBody> },
  TContext
> => {
  return useMutation(getCreateCoachMutationOptions(options));
};

/**
 * @summary Get coach with full contract and insurance details
 */
export const getGetCoachUrl = (id: number) => {
  return `/api/coaches/${id}`;
};

export const getCoach = async (
  id: number,
  options?: RequestInit,
): Promise<CoachDetail> => {
  return customFetch<CoachDetail>(getGetCoachUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCoachQueryKey = (id: number) => {
  return [`/api/coaches/${id}`] as const;
};

export const getGetCoachQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoach>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCoach>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCoachQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoach>>> = ({
    signal,
  }) => getCoach(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCoach>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetCoachQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCoach>>
>;
export type GetCoachQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get coach with full contract and insurance details
 */

export function useGetCoach<
  TData = Awaited<ReturnType<typeof getCoach>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCoach>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCoachQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update coach profile
 */
export const getUpdateCoachUrl = (id: number) => {
  return `/api/coaches/${id}`;
};

export const updateCoach = async (
  id: number,
  updateCoachBody: UpdateCoachBody,
  options?: RequestInit,
): Promise<Coach> => {
  return customFetch<Coach>(getUpdateCoachUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCoachBody),
  });
};

export const getUpdateCoachMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCoach>>,
    TError,
    { id: number; data: BodyType<UpdateCoachBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCoach>>,
  TError,
  { id: number; data: BodyType<UpdateCoachBody> },
  TContext
> => {
  const mutationKey = ["updateCoach"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCoach>>,
    { id: number; data: BodyType<UpdateCoachBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCoach(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCoachMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCoach>>
>;
export type UpdateCoachMutationBody = BodyType<UpdateCoachBody>;
export type UpdateCoachMutationError = ErrorType<unknown>;

/**
 * @summary Update coach profile
 */
export const useUpdateCoach = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCoach>>,
    TError,
    { id: number; data: BodyType<UpdateCoachBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCoach>>,
  TError,
  { id: number; data: BodyType<UpdateCoachBody> },
  TContext
> => {
  return useMutation(getUpdateCoachMutationOptions(options));
};

/**
 * @summary Delete a coach
 */
export const getDeleteCoachUrl = (id: number) => {
  return `/api/coaches/${id}`;
};

export const deleteCoach = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCoachUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCoachMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCoach>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCoach>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCoach"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCoach>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCoach(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCoachMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCoach>>
>;

export type DeleteCoachMutationError = ErrorType<unknown>;

/**
 * @summary Delete a coach
 */
export const useDeleteCoach = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCoach>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCoach>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCoachMutationOptions(options));
};

/**
 * @summary List all contracts
 */
export const getListContractsUrl = (params?: ListContractsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/contracts?${stringifiedParams}`
    : `/api/contracts`;
};

export const listContracts = async (
  params?: ListContractsParams,
  options?: RequestInit,
): Promise<ContractListItem[]> => {
  return customFetch<ContractListItem[]>(getListContractsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListContractsQueryKey = (params?: ListContractsParams) => {
  return [`/api/contracts`, ...(params ? [params] : [])] as const;
};

export const getListContractsQueryOptions = <
  TData = Awaited<ReturnType<typeof listContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListContractsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContracts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListContractsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listContracts>>> = ({
    signal,
  }) => listContracts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContracts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContractsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContracts>>
>;
export type ListContractsQueryError = ErrorType<unknown>;

/**
 * @summary List all contracts
 */

export function useListContracts<
  TData = Awaited<ReturnType<typeof listContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListContractsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContracts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContractsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new contract
 */
export const getCreateContractUrl = () => {
  return `/api/contracts`;
};

export const createContract = async (
  createContractBody: CreateContractBody,
  options?: RequestInit,
): Promise<Contract> => {
  return customFetch<Contract>(getCreateContractUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createContractBody),
  });
};

export const getCreateContractMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContract>>,
    TError,
    { data: BodyType<CreateContractBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContract>>,
  TError,
  { data: BodyType<CreateContractBody> },
  TContext
> => {
  const mutationKey = ["createContract"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContract>>,
    { data: BodyType<CreateContractBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createContract(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateContractMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContract>>
>;
export type CreateContractMutationBody = BodyType<CreateContractBody>;
export type CreateContractMutationError = ErrorType<unknown>;

/**
 * @summary Create a new contract
 */
export const useCreateContract = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContract>>,
    TError,
    { data: BodyType<CreateContractBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createContract>>,
  TError,
  { data: BodyType<CreateContractBody> },
  TContext
> => {
  return useMutation(getCreateContractMutationOptions(options));
};

/**
 * Returns only the minimal fields the Timeline view needs in a single SQL query, without per-row insurance status lookups.
 * @summary Lightweight contracts list optimized for the Timeline view
 */
export const getListContractsTimelineUrl = () => {
  return `/api/contracts/timeline`;
};

export const listContractsTimeline = async (
  options?: RequestInit,
): Promise<ContractTimelineItem[]> => {
  return customFetch<ContractTimelineItem[]>(getListContractsTimelineUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListContractsTimelineQueryKey = () => {
  return [`/api/contracts/timeline`] as const;
};

export const getListContractsTimelineQueryOptions = <
  TData = Awaited<ReturnType<typeof listContractsTimeline>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listContractsTimeline>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListContractsTimelineQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContractsTimeline>>
  > = ({ signal }) => listContractsTimeline({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContractsTimeline>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContractsTimelineQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContractsTimeline>>
>;
export type ListContractsTimelineQueryError = ErrorType<unknown>;

/**
 * @summary Lightweight contracts list optimized for the Timeline view
 */

export function useListContractsTimeline<
  TData = Awaited<ReturnType<typeof listContractsTimeline>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listContractsTimeline>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContractsTimelineQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get contract details
 */
export const getGetContractUrl = (id: number) => {
  return `/api/contracts/${id}`;
};

export const getContract = async (
  id: number,
  options?: RequestInit,
): Promise<Contract> => {
  return customFetch<Contract>(getGetContractUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContractQueryKey = (id: number) => {
  return [`/api/contracts/${id}`] as const;
};

export const getGetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof getContract>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContract>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContractQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContract>>> = ({
    signal,
  }) => getContract(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContract>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContract>>
>;
export type GetContractQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get contract details
 */

export function useGetContract<
  TData = Awaited<ReturnType<typeof getContract>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContract>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContractQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update contract
 */
export const getUpdateContractUrl = (id: number) => {
  return `/api/contracts/${id}`;
};

export const updateContract = async (
  id: number,
  updateContractBody: UpdateContractBody,
  options?: RequestInit,
): Promise<Contract> => {
  return customFetch<Contract>(getUpdateContractUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateContractBody),
  });
};

export const getUpdateContractMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContract>>,
    TError,
    { id: number; data: BodyType<UpdateContractBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContract>>,
  TError,
  { id: number; data: BodyType<UpdateContractBody> },
  TContext
> => {
  const mutationKey = ["updateContract"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContract>>,
    { id: number; data: BodyType<UpdateContractBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateContract(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateContractMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateContract>>
>;
export type UpdateContractMutationBody = BodyType<UpdateContractBody>;
export type UpdateContractMutationError = ErrorType<unknown>;

/**
 * @summary Update contract
 */
export const useUpdateContract = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContract>>,
    TError,
    { id: number; data: BodyType<UpdateContractBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateContract>>,
  TError,
  { id: number; data: BodyType<UpdateContractBody> },
  TContext
> => {
  return useMutation(getUpdateContractMutationOptions(options));
};

/**
 * @summary Delete contract and any attached documents
 */
export const getDeleteContractUrl = (id: number) => {
  return `/api/contracts/${id}`;
};

export const deleteContract = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteContractUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteContractMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContract>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContract>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteContract"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContract>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteContract(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContractMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContract>>
>;

export type DeleteContractMutationError = ErrorType<unknown>;

/**
 * @summary Delete contract and any attached documents
 */
export const useDeleteContract = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContract>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteContract>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteContractMutationOptions(options));
};

/**
 * Creates a new contract row (`documentKind=contract`) seeded from the
given term sheet, with `termSheetId` set to the originating row for
traceability. The term sheet itself is not modified. Returns the
newly-created draft contract.

 * @summary Create a draft full contract from an accepted term sheet
 */
export const getPromoteTermSheetToContractUrl = (id: number) => {
  return `/api/contracts/${id}/promote-to-contract`;
};

export const promoteTermSheetToContract = async (
  id: number,
  options?: RequestInit,
): Promise<Contract> => {
  return customFetch<Contract>(getPromoteTermSheetToContractUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPromoteTermSheetToContractMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteTermSheetToContract>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoteTermSheetToContract>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["promoteTermSheetToContract"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoteTermSheetToContract>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return promoteTermSheetToContract(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoteTermSheetToContractMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoteTermSheetToContract>>
>;

export type PromoteTermSheetToContractMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a draft full contract from an accepted term sheet
 */
export const usePromoteTermSheetToContract = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteTermSheetToContract>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoteTermSheetToContract>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPromoteTermSheetToContractMutationOptions(options));
};

/**
 * Updates the `termSheetStatus` field — the candidate-facing state
(sent / accepted / declined / countered). Internal approval state
is managed via the existing approval engine.

 * @summary Update the external status of a term sheet
 */
export const getUpdateTermSheetStatusUrl = (id: number) => {
  return `/api/contracts/${id}/term-sheet-status`;
};

export const updateTermSheetStatus = async (
  id: number,
  updateTermSheetStatusBody: UpdateTermSheetStatusBody,
  options?: RequestInit,
): Promise<Contract> => {
  return customFetch<Contract>(getUpdateTermSheetStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTermSheetStatusBody),
  });
};

export const getUpdateTermSheetStatusMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTermSheetStatus>>,
    TError,
    { id: number; data: BodyType<UpdateTermSheetStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTermSheetStatus>>,
  TError,
  { id: number; data: BodyType<UpdateTermSheetStatusBody> },
  TContext
> => {
  const mutationKey = ["updateTermSheetStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTermSheetStatus>>,
    { id: number; data: BodyType<UpdateTermSheetStatusBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTermSheetStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTermSheetStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTermSheetStatus>>
>;
export type UpdateTermSheetStatusMutationBody =
  BodyType<UpdateTermSheetStatusBody>;
export type UpdateTermSheetStatusMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update the external status of a term sheet
 */
export const useUpdateTermSheetStatus = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTermSheetStatus>>,
    TError,
    { id: number; data: BodyType<UpdateTermSheetStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTermSheetStatus>>,
  TError,
  { id: number; data: BodyType<UpdateTermSheetStatusBody> },
  TContext
> => {
  return useMutation(getUpdateTermSheetStatusMutationOptions(options));
};

/**
 * Returns all stored snapshots (internal sends and received counters)
for the given term sheet, ordered by `versionNumber` ascending.

 * @summary List versioned snapshots of a term sheet
 */
export const getListTermSheetVersionsUrl = (id: number) => {
  return `/api/contracts/${id}/term-sheet-versions`;
};

export const listTermSheetVersions = async (
  id: number,
  options?: RequestInit,
): Promise<TermSheetVersion[]> => {
  return customFetch<TermSheetVersion[]>(getListTermSheetVersionsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListTermSheetVersionsQueryKey = (id: number) => {
  return [`/api/contracts/${id}/term-sheet-versions`] as const;
};

export const getListTermSheetVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTermSheetVersions>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTermSheetVersions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTermSheetVersionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTermSheetVersions>>
  > = ({ signal }) => listTermSheetVersions(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTermSheetVersions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTermSheetVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTermSheetVersions>>
>;
export type ListTermSheetVersionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List versioned snapshots of a term sheet
 */

export function useListTermSheetVersions<
  TData = Awaited<ReturnType<typeof listTermSheetVersions>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTermSheetVersions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTermSheetVersionsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Record a candidate counter-offer on a term sheet
 */
export const getRecordTermSheetCounterUrl = (id: number) => {
  return `/api/contracts/${id}/term-sheet-counter`;
};

export const recordTermSheetCounter = async (
  id: number,
  recordTermSheetCounterBody: RecordTermSheetCounterBody,
  options?: RequestInit,
): Promise<TermSheetVersion> => {
  return customFetch<TermSheetVersion>(getRecordTermSheetCounterUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recordTermSheetCounterBody),
  });
};

export const getRecordTermSheetCounterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordTermSheetCounter>>,
    TError,
    { id: number; data: BodyType<RecordTermSheetCounterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordTermSheetCounter>>,
  TError,
  { id: number; data: BodyType<RecordTermSheetCounterBody> },
  TContext
> => {
  const mutationKey = ["recordTermSheetCounter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordTermSheetCounter>>,
    { id: number; data: BodyType<RecordTermSheetCounterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return recordTermSheetCounter(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordTermSheetCounterMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordTermSheetCounter>>
>;
export type RecordTermSheetCounterMutationBody =
  BodyType<RecordTermSheetCounterBody>;
export type RecordTermSheetCounterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Record a candidate counter-offer on a term sheet
 */
export const useRecordTermSheetCounter = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordTermSheetCounter>>,
    TError,
    { id: number; data: BodyType<RecordTermSheetCounterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordTermSheetCounter>>,
  TError,
  { id: number; data: BodyType<RecordTermSheetCounterBody> },
  TContext
> => {
  return useMutation(getRecordTermSheetCounterMutationOptions(options));
};

/**
 * Applies the most recent "counter" snapshot to the term sheet row's
primary fields and transitions status to "accepted".

 * @summary Accept the latest counter on a term sheet
 */
export const getAcceptTermSheetCounterUrl = (id: number) => {
  return `/api/contracts/${id}/term-sheet-accept-counter`;
};

export const acceptTermSheetCounter = async (
  id: number,
  acceptTermSheetCounterBody: AcceptTermSheetCounterBody,
  options?: RequestInit,
): Promise<Contract> => {
  return customFetch<Contract>(getAcceptTermSheetCounterUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptTermSheetCounterBody),
  });
};

export const getAcceptTermSheetCounterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTermSheetCounter>>,
    TError,
    { id: number; data: BodyType<AcceptTermSheetCounterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptTermSheetCounter>>,
  TError,
  { id: number; data: BodyType<AcceptTermSheetCounterBody> },
  TContext
> => {
  const mutationKey = ["acceptTermSheetCounter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptTermSheetCounter>>,
    { id: number; data: BodyType<AcceptTermSheetCounterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return acceptTermSheetCounter(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptTermSheetCounterMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptTermSheetCounter>>
>;
export type AcceptTermSheetCounterMutationBody =
  BodyType<AcceptTermSheetCounterBody>;
export type AcceptTermSheetCounterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Accept the latest counter on a term sheet
 */
export const useAcceptTermSheetCounter = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTermSheetCounter>>,
    TError,
    { id: number; data: BodyType<AcceptTermSheetCounterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptTermSheetCounter>>,
  TError,
  { id: number; data: BodyType<AcceptTermSheetCounterBody> },
  TContext
> => {
  return useMutation(getAcceptTermSheetCounterMutationOptions(options));
};

/**
 * @summary Transition a contract to a new lifecycle state
 */
export const getTransitionContractLifecycleUrl = (id: number) => {
  return `/api/contracts/${id}/lifecycle`;
};

export const transitionContractLifecycle = async (
  id: number,
  transitionLifecycleBody: TransitionLifecycleBody,
  options?: RequestInit,
): Promise<LifecycleTransitionResult> => {
  return customFetch<LifecycleTransitionResult>(
    getTransitionContractLifecycleUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(transitionLifecycleBody),
    },
  );
};

export const getTransitionContractLifecycleMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionContractLifecycle>>,
    TError,
    { id: number; data: BodyType<TransitionLifecycleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transitionContractLifecycle>>,
  TError,
  { id: number; data: BodyType<TransitionLifecycleBody> },
  TContext
> => {
  const mutationKey = ["transitionContractLifecycle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionContractLifecycle>>,
    { id: number; data: BodyType<TransitionLifecycleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return transitionContractLifecycle(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransitionContractLifecycleMutationResult = NonNullable<
  Awaited<ReturnType<typeof transitionContractLifecycle>>
>;
export type TransitionContractLifecycleMutationBody =
  BodyType<TransitionLifecycleBody>;
export type TransitionContractLifecycleMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Transition a contract to a new lifecycle state
 */
export const useTransitionContractLifecycle = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionContractLifecycle>>,
    TError,
    { id: number; data: BodyType<TransitionLifecycleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof transitionContractLifecycle>>,
  TError,
  { id: number; data: BodyType<TransitionLifecycleBody> },
  TContext
> => {
  return useMutation(getTransitionContractLifecycleMutationOptions(options));
};

/**
 * @summary Send contract to coach or representation for external negotiation
 */
export const getSendContractExternalUrl = (id: number) => {
  return `/api/contracts/${id}/send-external`;
};

export const sendContractExternal = async (
  id: number,
  sendExternalBody: SendExternalBody,
  options?: RequestInit,
): Promise<SendExternalResult> => {
  return customFetch<SendExternalResult>(getSendContractExternalUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendExternalBody),
  });
};

export const getSendContractExternalMutationOptions = <
  TError = ErrorType<SendExternalConflict>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendContractExternal>>,
    TError,
    { id: number; data: BodyType<SendExternalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendContractExternal>>,
  TError,
  { id: number; data: BodyType<SendExternalBody> },
  TContext
> => {
  const mutationKey = ["sendContractExternal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendContractExternal>>,
    { id: number; data: BodyType<SendExternalBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendContractExternal(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendContractExternalMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendContractExternal>>
>;
export type SendContractExternalMutationBody = BodyType<SendExternalBody>;
export type SendContractExternalMutationError = ErrorType<SendExternalConflict>;

/**
 * @summary Send contract to coach or representation for external negotiation
 */
export const useSendContractExternal = <
  TError = ErrorType<SendExternalConflict>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendContractExternal>>,
    TError,
    { id: number; data: BodyType<SendExternalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendContractExternal>>,
  TError,
  { id: number; data: BodyType<SendExternalBody> },
  TContext
> => {
  return useMutation(getSendContractExternalMutationOptions(options));
};

/**
 * @summary Log an incoming counter-proposal from the external party
 */
export const getLogContractCounterUrl = (id: number) => {
  return `/api/contracts/${id}/log-counter`;
};

export const logContractCounter = async (
  id: number,
  logCounterBody: LogCounterBody,
  options?: RequestInit,
): Promise<LogCounterResult> => {
  return customFetch<LogCounterResult>(getLogContractCounterUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(logCounterBody),
  });
};

export const getLogContractCounterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logContractCounter>>,
    TError,
    { id: number; data: BodyType<LogCounterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logContractCounter>>,
  TError,
  { id: number; data: BodyType<LogCounterBody> },
  TContext
> => {
  const mutationKey = ["logContractCounter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logContractCounter>>,
    { id: number; data: BodyType<LogCounterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return logContractCounter(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogContractCounterMutationResult = NonNullable<
  Awaited<ReturnType<typeof logContractCounter>>
>;
export type LogContractCounterMutationBody = BodyType<LogCounterBody>;
export type LogContractCounterMutationError = ErrorType<unknown>;

/**
 * @summary Log an incoming counter-proposal from the external party
 */
export const useLogContractCounter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logContractCounter>>,
    TError,
    { id: number; data: BodyType<LogCounterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logContractCounter>>,
  TError,
  { id: number; data: BodyType<LogCounterBody> },
  TContext
> => {
  return useMutation(getLogContractCounterMutationOptions(options));
};

/**
 * When muted, the in-app notifications fired by
`notifyNegotiationEmailFailure` (bounce, spam complaint, delivery
failure) are suppressed for this contract. Webhook processing
(round status, last-error string, etc.) continues to run; only
the user-facing alert is silenced. Open to any org member with
writable access so individual contract owners can quiet their own
contracts without involving an admin.

 * @summary Mute or un-mute negotiation delivery-failure alerts for a contract
 */
export const getSetContractDeliveryAlertsMuteUrl = (id: number) => {
  return `/api/contracts/${id}/delivery-alerts-mute`;
};

export const setContractDeliveryAlertsMute = async (
  id: number,
  setContractDeliveryAlertsMuteBody: SetContractDeliveryAlertsMuteBody,
  options?: RequestInit,
): Promise<ContractDeliveryAlertsMuteState> => {
  return customFetch<ContractDeliveryAlertsMuteState>(
    getSetContractDeliveryAlertsMuteUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setContractDeliveryAlertsMuteBody),
    },
  );
};

export const getSetContractDeliveryAlertsMuteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setContractDeliveryAlertsMute>>,
    TError,
    { id: number; data: BodyType<SetContractDeliveryAlertsMuteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setContractDeliveryAlertsMute>>,
  TError,
  { id: number; data: BodyType<SetContractDeliveryAlertsMuteBody> },
  TContext
> => {
  const mutationKey = ["setContractDeliveryAlertsMute"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setContractDeliveryAlertsMute>>,
    { id: number; data: BodyType<SetContractDeliveryAlertsMuteBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setContractDeliveryAlertsMute(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetContractDeliveryAlertsMuteMutationResult = NonNullable<
  Awaited<ReturnType<typeof setContractDeliveryAlertsMute>>
>;
export type SetContractDeliveryAlertsMuteMutationBody =
  BodyType<SetContractDeliveryAlertsMuteBody>;
export type SetContractDeliveryAlertsMuteMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Mute or un-mute negotiation delivery-failure alerts for a contract
 */
export const useSetContractDeliveryAlertsMute = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setContractDeliveryAlertsMute>>,
    TError,
    { id: number; data: BodyType<SetContractDeliveryAlertsMuteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setContractDeliveryAlertsMute>>,
  TError,
  { id: number; data: BodyType<SetContractDeliveryAlertsMuteBody> },
  TContext
> => {
  return useMutation(getSetContractDeliveryAlertsMuteMutationOptions(options));
};

/**
 * @summary List all negotiation rounds for a contract
 */
export const getListNegotiationRoundsUrl = (id: number) => {
  return `/api/contracts/${id}/negotiation-rounds`;
};

export const listNegotiationRounds = async (
  id: number,
  options?: RequestInit,
): Promise<NegotiationRound[]> => {
  return customFetch<NegotiationRound[]>(getListNegotiationRoundsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListNegotiationRoundsQueryKey = (id: number) => {
  return [`/api/contracts/${id}/negotiation-rounds`] as const;
};

export const getListNegotiationRoundsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNegotiationRounds>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNegotiationRounds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListNegotiationRoundsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNegotiationRounds>>
  > = ({ signal }) => listNegotiationRounds(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listNegotiationRounds>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNegotiationRoundsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNegotiationRounds>>
>;
export type ListNegotiationRoundsQueryError = ErrorType<unknown>;

/**
 * @summary List all negotiation rounds for a contract
 */

export function useListNegotiationRounds<
  TData = Awaited<ReturnType<typeof listNegotiationRounds>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNegotiationRounds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNegotiationRoundsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List negotiation items (issue tracking) for a contract
 */
export const getListContractNegotiationItemsUrl = (contractId: number) => {
  return `/api/contracts/${contractId}/negotiation-items`;
};

export const listContractNegotiationItems = async (
  contractId: number,
  options?: RequestInit,
): Promise<NegotiationItem[]> => {
  return customFetch<NegotiationItem[]>(
    getListContractNegotiationItemsUrl(contractId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListContractNegotiationItemsQueryKey = (contractId: number) => {
  return [`/api/contracts/${contractId}/negotiation-items`] as const;
};

export const getListContractNegotiationItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof listContractNegotiationItems>>,
  TError = ErrorType<ErrorResponse>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractNegotiationItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListContractNegotiationItemsQueryKey(contractId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContractNegotiationItems>>
  > = ({ signal }) =>
    listContractNegotiationItems(contractId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!contractId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listContractNegotiationItems>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContractNegotiationItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContractNegotiationItems>>
>;
export type ListContractNegotiationItemsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List negotiation items (issue tracking) for a contract
 */

export function useListContractNegotiationItems<
  TData = Awaited<ReturnType<typeof listContractNegotiationItems>>,
  TError = ErrorType<ErrorResponse>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractNegotiationItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContractNegotiationItemsQueryOptions(
    contractId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a negotiation item (issue tracking) on a contract
 */
export const getCreateContractNegotiationItemUrl = (contractId: number) => {
  return `/api/contracts/${contractId}/negotiation-items`;
};

export const createContractNegotiationItem = async (
  contractId: number,
  createNegotiationItemBody: CreateNegotiationItemBody,
  options?: RequestInit,
): Promise<NegotiationItem> => {
  return customFetch<NegotiationItem>(
    getCreateContractNegotiationItemUrl(contractId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createNegotiationItemBody),
    },
  );
};

export const getCreateContractNegotiationItemMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContractNegotiationItem>>,
    TError,
    { contractId: number; data: BodyType<CreateNegotiationItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContractNegotiationItem>>,
  TError,
  { contractId: number; data: BodyType<CreateNegotiationItemBody> },
  TContext
> => {
  const mutationKey = ["createContractNegotiationItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContractNegotiationItem>>,
    { contractId: number; data: BodyType<CreateNegotiationItemBody> }
  > = (props) => {
    const { contractId, data } = props ?? {};

    return createContractNegotiationItem(contractId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateContractNegotiationItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContractNegotiationItem>>
>;
export type CreateContractNegotiationItemMutationBody =
  BodyType<CreateNegotiationItemBody>;
export type CreateContractNegotiationItemMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Create a negotiation item (issue tracking) on a contract
 */
export const useCreateContractNegotiationItem = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContractNegotiationItem>>,
    TError,
    { contractId: number; data: BodyType<CreateNegotiationItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createContractNegotiationItem>>,
  TError,
  { contractId: number; data: BodyType<CreateNegotiationItemBody> },
  TContext
> => {
  return useMutation(getCreateContractNegotiationItemMutationOptions(options));
};

/**
 * @summary Update a negotiation item on a contract
 */
export const getUpdateContractNegotiationItemUrl = (
  contractId: number,
  itemId: number,
) => {
  return `/api/contracts/${contractId}/negotiation-items/${itemId}`;
};

export const updateContractNegotiationItem = async (
  contractId: number,
  itemId: number,
  updateNegotiationItemBody: UpdateNegotiationItemBody,
  options?: RequestInit,
): Promise<NegotiationItem> => {
  return customFetch<NegotiationItem>(
    getUpdateContractNegotiationItemUrl(contractId, itemId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateNegotiationItemBody),
    },
  );
};

export const getUpdateContractNegotiationItemMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContractNegotiationItem>>,
    TError,
    {
      contractId: number;
      itemId: number;
      data: BodyType<UpdateNegotiationItemBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContractNegotiationItem>>,
  TError,
  {
    contractId: number;
    itemId: number;
    data: BodyType<UpdateNegotiationItemBody>;
  },
  TContext
> => {
  const mutationKey = ["updateContractNegotiationItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContractNegotiationItem>>,
    {
      contractId: number;
      itemId: number;
      data: BodyType<UpdateNegotiationItemBody>;
    }
  > = (props) => {
    const { contractId, itemId, data } = props ?? {};

    return updateContractNegotiationItem(
      contractId,
      itemId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateContractNegotiationItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateContractNegotiationItem>>
>;
export type UpdateContractNegotiationItemMutationBody =
  BodyType<UpdateNegotiationItemBody>;
export type UpdateContractNegotiationItemMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Update a negotiation item on a contract
 */
export const useUpdateContractNegotiationItem = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContractNegotiationItem>>,
    TError,
    {
      contractId: number;
      itemId: number;
      data: BodyType<UpdateNegotiationItemBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateContractNegotiationItem>>,
  TError,
  {
    contractId: number;
    itemId: number;
    data: BodyType<UpdateNegotiationItemBody>;
  },
  TContext
> => {
  return useMutation(getUpdateContractNegotiationItemMutationOptions(options));
};

/**
 * @summary Delete a negotiation item from a contract
 */
export const getDeleteContractNegotiationItemUrl = (
  contractId: number,
  itemId: number,
) => {
  return `/api/contracts/${contractId}/negotiation-items/${itemId}`;
};

export const deleteContractNegotiationItem = async (
  contractId: number,
  itemId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(
    getDeleteContractNegotiationItemUrl(contractId, itemId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteContractNegotiationItemMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContractNegotiationItem>>,
    TError,
    { contractId: number; itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContractNegotiationItem>>,
  TError,
  { contractId: number; itemId: number },
  TContext
> => {
  const mutationKey = ["deleteContractNegotiationItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContractNegotiationItem>>,
    { contractId: number; itemId: number }
  > = (props) => {
    const { contractId, itemId } = props ?? {};

    return deleteContractNegotiationItem(contractId, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContractNegotiationItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContractNegotiationItem>>
>;

export type DeleteContractNegotiationItemMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Delete a negotiation item from a contract
 */
export const useDeleteContractNegotiationItem = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContractNegotiationItem>>,
    TError,
    { contractId: number; itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteContractNegotiationItem>>,
  TError,
  { contractId: number; itemId: number },
  TContext
> => {
  return useMutation(getDeleteContractNegotiationItemMutationOptions(options));
};

/**
 * @summary Lock or unlock the entire contract document (legal-only)
 */
export const getLockContractDocumentUrl = (id: number) => {
  return `/api/contracts/${id}/lock-document`;
};

export const lockContractDocument = async (
  id: number,
  lockDocumentBody: LockDocumentBody,
  options?: RequestInit,
): Promise<LockDocumentResult> => {
  return customFetch<LockDocumentResult>(getLockContractDocumentUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(lockDocumentBody),
  });
};

export const getLockContractDocumentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockContractDocument>>,
    TError,
    { id: number; data: BodyType<LockDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lockContractDocument>>,
  TError,
  { id: number; data: BodyType<LockDocumentBody> },
  TContext
> => {
  const mutationKey = ["lockContractDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lockContractDocument>>,
    { id: number; data: BodyType<LockDocumentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return lockContractDocument(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LockContractDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof lockContractDocument>>
>;
export type LockContractDocumentMutationBody = BodyType<LockDocumentBody>;
export type LockContractDocumentMutationError = ErrorType<unknown>;

/**
 * @summary Lock or unlock the entire contract document (legal-only)
 */
export const useLockContractDocument = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockContractDocument>>,
    TError,
    { id: number; data: BodyType<LockDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lockContractDocument>>,
  TError,
  { id: number; data: BodyType<LockDocumentBody> },
  TContext
> => {
  return useMutation(getLockContractDocumentMutationOptions(options));
};

/**
 * @summary Request a legal review for locked clauses on a contract
 */
export const getRequestContractLegalReviewUrl = (id: number) => {
  return `/api/contracts/${id}/request-legal-review`;
};

export const requestContractLegalReview = async (
  id: number,
  options?: RequestInit,
): Promise<RequestLegalReviewResult> => {
  return customFetch<RequestLegalReviewResult>(
    getRequestContractLegalReviewUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRequestContractLegalReviewMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestContractLegalReview>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestContractLegalReview>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["requestContractLegalReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestContractLegalReview>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return requestContractLegalReview(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestContractLegalReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestContractLegalReview>>
>;

export type RequestContractLegalReviewMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request a legal review for locked clauses on a contract
 */
export const useRequestContractLegalReview = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestContractLegalReview>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestContractLegalReview>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRequestContractLegalReviewMutationOptions(options));
};

/**
 * @summary Calculate the estimated buyout for a contract
 */
export const getCalculateContractBuyoutUrl = (id: number) => {
  return `/api/contracts/${id}/buyout`;
};

export const calculateContractBuyout = async (
  id: number,
  calculateBuyoutBody: CalculateBuyoutBody,
  options?: RequestInit,
): Promise<BuyoutBreakdown> => {
  return customFetch<BuyoutBreakdown>(getCalculateContractBuyoutUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(calculateBuyoutBody),
  });
};

export const getCalculateContractBuyoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calculateContractBuyout>>,
    TError,
    { id: number; data: BodyType<CalculateBuyoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof calculateContractBuyout>>,
  TError,
  { id: number; data: BodyType<CalculateBuyoutBody> },
  TContext
> => {
  const mutationKey = ["calculateContractBuyout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof calculateContractBuyout>>,
    { id: number; data: BodyType<CalculateBuyoutBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return calculateContractBuyout(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CalculateContractBuyoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof calculateContractBuyout>>
>;
export type CalculateContractBuyoutMutationBody = BodyType<CalculateBuyoutBody>;
export type CalculateContractBuyoutMutationError = ErrorType<unknown>;

/**
 * @summary Calculate the estimated buyout for a contract
 */
export const useCalculateContractBuyout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calculateContractBuyout>>,
    TError,
    { id: number; data: BodyType<CalculateBuyoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof calculateContractBuyout>>,
  TError,
  { id: number; data: BodyType<CalculateBuyoutBody> },
  TContext
> => {
  return useMutation(getCalculateContractBuyoutMutationOptions(options));
};

/**
 * @summary Request a presigned URL for direct file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  requestUploadUrlBody: RequestUploadUrlBody,
  options?: RequestInit,
): Promise<RequestUploadUrlResponse> => {
  return customFetch<RequestUploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(requestUploadUrlBody),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<RequestUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<RequestUploadUrlBody> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<RequestUploadUrlBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<RequestUploadUrlBody>;
export type RequestUploadUrlMutationError = ErrorType<unknown>;

/**
 * @summary Request a presigned URL for direct file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<RequestUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<RequestUploadUrlBody> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary List documents attached to a contract
 */
export const getListContractDocumentsUrl = (contractId: number) => {
  return `/api/contracts/${contractId}/documents`;
};

export const listContractDocuments = async (
  contractId: number,
  options?: RequestInit,
): Promise<ContractDocument[]> => {
  return customFetch<ContractDocument[]>(
    getListContractDocumentsUrl(contractId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListContractDocumentsQueryKey = (contractId: number) => {
  return [`/api/contracts/${contractId}/documents`] as const;
};

export const getListContractDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listContractDocuments>>,
  TError = ErrorType<unknown>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListContractDocumentsQueryKey(contractId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContractDocuments>>
  > = ({ signal }) =>
    listContractDocuments(contractId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!contractId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listContractDocuments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContractDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContractDocuments>>
>;
export type ListContractDocumentsQueryError = ErrorType<unknown>;

/**
 * @summary List documents attached to a contract
 */

export function useListContractDocuments<
  TData = Awaited<ReturnType<typeof listContractDocuments>>,
  TError = ErrorType<unknown>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContractDocumentsQueryOptions(
    contractId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Finalize an uploaded file as a contract document
 */
export const getCreateContractDocumentUrl = (contractId: number) => {
  return `/api/contracts/${contractId}/documents`;
};

export const createContractDocument = async (
  contractId: number,
  createContractDocumentBody: CreateContractDocumentBody,
  options?: RequestInit,
): Promise<ContractDocument> => {
  return customFetch<ContractDocument>(
    getCreateContractDocumentUrl(contractId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createContractDocumentBody),
    },
  );
};

export const getCreateContractDocumentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContractDocument>>,
    TError,
    { contractId: number; data: BodyType<CreateContractDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContractDocument>>,
  TError,
  { contractId: number; data: BodyType<CreateContractDocumentBody> },
  TContext
> => {
  const mutationKey = ["createContractDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContractDocument>>,
    { contractId: number; data: BodyType<CreateContractDocumentBody> }
  > = (props) => {
    const { contractId, data } = props ?? {};

    return createContractDocument(contractId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateContractDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContractDocument>>
>;
export type CreateContractDocumentMutationBody =
  BodyType<CreateContractDocumentBody>;
export type CreateContractDocumentMutationError = ErrorType<unknown>;

/**
 * @summary Finalize an uploaded file as a contract document
 */
export const useCreateContractDocument = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContractDocument>>,
    TError,
    { contractId: number; data: BodyType<CreateContractDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createContractDocument>>,
  TError,
  { contractId: number; data: BodyType<CreateContractDocumentBody> },
  TContext
> => {
  return useMutation(getCreateContractDocumentMutationOptions(options));
};

/**
 * @summary Download all documents for a contract as a single ZIP archive
 */
export const getDownloadAllContractDocumentsUrl = (contractId: number) => {
  return `/api/contracts/${contractId}/documents/zip`;
};

export const downloadAllContractDocuments = async (
  contractId: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadAllContractDocumentsUrl(contractId), {
    ...options,
    method: "GET",
  });
};

export const getDownloadAllContractDocumentsQueryKey = (contractId: number) => {
  return [`/api/contracts/${contractId}/documents/zip`] as const;
};

export const getDownloadAllContractDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadAllContractDocuments>>,
  TError = ErrorType<ErrorResponse>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadAllContractDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadAllContractDocumentsQueryKey(contractId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadAllContractDocuments>>
  > = ({ signal }) =>
    downloadAllContractDocuments(contractId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!contractId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadAllContractDocuments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadAllContractDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadAllContractDocuments>>
>;
export type DownloadAllContractDocumentsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Download all documents for a contract as a single ZIP archive
 */

export function useDownloadAllContractDocuments<
  TData = Awaited<ReturnType<typeof downloadAllContractDocuments>>,
  TError = ErrorType<ErrorResponse>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadAllContractDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadAllContractDocumentsQueryOptions(
    contractId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download a contract document (org-scoped, authenticated)
 */
export const getDownloadContractDocumentUrl = (id: number) => {
  return `/api/contract-documents/${id}/download`;
};

export const downloadContractDocument = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadContractDocumentUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadContractDocumentQueryKey = (id: number) => {
  return [`/api/contract-documents/${id}/download`] as const;
};

export const getDownloadContractDocumentQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadContractDocument>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadContractDocument>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadContractDocumentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadContractDocument>>
  > = ({ signal }) =>
    downloadContractDocument(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadContractDocument>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadContractDocumentQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadContractDocument>>
>;
export type DownloadContractDocumentQueryError = ErrorType<unknown>;

/**
 * @summary Download a contract document (org-scoped, authenticated)
 */

export function useDownloadContractDocument<
  TData = Awaited<ReturnType<typeof downloadContractDocument>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadContractDocument>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadContractDocumentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a contract document
 */
export const getDeleteContractDocumentUrl = (id: number) => {
  return `/api/contract-documents/${id}`;
};

export const deleteContractDocument = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteContractDocumentUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteContractDocumentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContractDocument>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContractDocument>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteContractDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContractDocument>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteContractDocument(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContractDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContractDocument>>
>;

export type DeleteContractDocumentMutationError = ErrorType<unknown>;

/**
 * @summary Delete a contract document
 */
export const useDeleteContractDocument = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContractDocument>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteContractDocument>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteContractDocumentMutationOptions(options));
};

/**
 * @summary List all insurance policies
 */
export const getListInsurancePoliciesUrl = (
  params?: ListInsurancePoliciesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/insurance?${stringifiedParams}`
    : `/api/insurance`;
};

export const listInsurancePolicies = async (
  params?: ListInsurancePoliciesParams,
  options?: RequestInit,
): Promise<InsurancePolicy[]> => {
  return customFetch<InsurancePolicy[]>(getListInsurancePoliciesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInsurancePoliciesQueryKey = (
  params?: ListInsurancePoliciesParams,
) => {
  return [`/api/insurance`, ...(params ? [params] : [])] as const;
};

export const getListInsurancePoliciesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInsurancePolicies>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInsurancePoliciesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInsurancePolicies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInsurancePoliciesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInsurancePolicies>>
  > = ({ signal }) =>
    listInsurancePolicies(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInsurancePolicies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInsurancePoliciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInsurancePolicies>>
>;
export type ListInsurancePoliciesQueryError = ErrorType<unknown>;

/**
 * @summary List all insurance policies
 */

export function useListInsurancePolicies<
  TData = Awaited<ReturnType<typeof listInsurancePolicies>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInsurancePoliciesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInsurancePolicies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInsurancePoliciesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create insurance policy record
 */
export const getCreateInsurancePolicyUrl = () => {
  return `/api/insurance`;
};

export const createInsurancePolicy = async (
  createInsurancePolicyBody: CreateInsurancePolicyBody,
  options?: RequestInit,
): Promise<InsurancePolicy> => {
  return customFetch<InsurancePolicy>(getCreateInsurancePolicyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInsurancePolicyBody),
  });
};

export const getCreateInsurancePolicyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInsurancePolicy>>,
    TError,
    { data: BodyType<CreateInsurancePolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInsurancePolicy>>,
  TError,
  { data: BodyType<CreateInsurancePolicyBody> },
  TContext
> => {
  const mutationKey = ["createInsurancePolicy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInsurancePolicy>>,
    { data: BodyType<CreateInsurancePolicyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInsurancePolicy(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInsurancePolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInsurancePolicy>>
>;
export type CreateInsurancePolicyMutationBody =
  BodyType<CreateInsurancePolicyBody>;
export type CreateInsurancePolicyMutationError = ErrorType<unknown>;

/**
 * @summary Create insurance policy record
 */
export const useCreateInsurancePolicy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInsurancePolicy>>,
    TError,
    { data: BodyType<CreateInsurancePolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInsurancePolicy>>,
  TError,
  { data: BodyType<CreateInsurancePolicyBody> },
  TContext
> => {
  return useMutation(getCreateInsurancePolicyMutationOptions(options));
};

/**
 * @summary Get insurance compliance summary by coach
 */
export const getGetInsuranceSummaryUrl = () => {
  return `/api/insurance/summary`;
};

export const getInsuranceSummary = async (
  options?: RequestInit,
): Promise<InsuranceCoachSummary[]> => {
  return customFetch<InsuranceCoachSummary[]>(getGetInsuranceSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetInsuranceSummaryQueryKey = () => {
  return [`/api/insurance/summary`] as const;
};

export const getGetInsuranceSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getInsuranceSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getInsuranceSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInsuranceSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInsuranceSummary>>
  > = ({ signal }) => getInsuranceSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInsuranceSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInsuranceSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInsuranceSummary>>
>;
export type GetInsuranceSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get insurance compliance summary by coach
 */

export function useGetInsuranceSummary<
  TData = Awaited<ReturnType<typeof getInsuranceSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getInsuranceSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInsuranceSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update insurance policy
 */
export const getUpdateInsurancePolicyUrl = (id: number) => {
  return `/api/insurance/${id}`;
};

export const updateInsurancePolicy = async (
  id: number,
  updateInsurancePolicyBody: UpdateInsurancePolicyBody,
  options?: RequestInit,
): Promise<InsurancePolicy> => {
  return customFetch<InsurancePolicy>(getUpdateInsurancePolicyUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInsurancePolicyBody),
  });
};

export const getUpdateInsurancePolicyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInsurancePolicy>>,
    TError,
    { id: number; data: BodyType<UpdateInsurancePolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInsurancePolicy>>,
  TError,
  { id: number; data: BodyType<UpdateInsurancePolicyBody> },
  TContext
> => {
  const mutationKey = ["updateInsurancePolicy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInsurancePolicy>>,
    { id: number; data: BodyType<UpdateInsurancePolicyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInsurancePolicy(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInsurancePolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInsurancePolicy>>
>;
export type UpdateInsurancePolicyMutationBody =
  BodyType<UpdateInsurancePolicyBody>;
export type UpdateInsurancePolicyMutationError = ErrorType<unknown>;

/**
 * @summary Update insurance policy
 */
export const useUpdateInsurancePolicy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInsurancePolicy>>,
    TError,
    { id: number; data: BodyType<UpdateInsurancePolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInsurancePolicy>>,
  TError,
  { id: number; data: BodyType<UpdateInsurancePolicyBody> },
  TContext
> => {
  return useMutation(getUpdateInsurancePolicyMutationOptions(options));
};

/**
 * @summary Delete insurance policy
 */
export const getDeleteInsurancePolicyUrl = (id: number) => {
  return `/api/insurance/${id}`;
};

export const deleteInsurancePolicy = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInsurancePolicyUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInsurancePolicyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInsurancePolicy>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInsurancePolicy>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInsurancePolicy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInsurancePolicy>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInsurancePolicy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInsurancePolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInsurancePolicy>>
>;

export type DeleteInsurancePolicyMutationError = ErrorType<unknown>;

/**
 * @summary Delete insurance policy
 */
export const useDeleteInsurancePolicy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInsurancePolicy>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInsurancePolicy>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInsurancePolicyMutationOptions(options));
};

/**
 * @summary List all renewals (including auto-candidates within 12mo of expiry)
 */
export const getListRenewalsUrl = (params?: ListRenewalsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/renewals?${stringifiedParams}`
    : `/api/renewals`;
};

export const listRenewals = async (
  params?: ListRenewalsParams,
  options?: RequestInit,
): Promise<Renewal[]> => {
  return customFetch<Renewal[]>(getListRenewalsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListRenewalsQueryKey = (params?: ListRenewalsParams) => {
  return [`/api/renewals`, ...(params ? [params] : [])] as const;
};

export const getListRenewalsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRenewals>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRenewalsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRenewals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRenewalsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRenewals>>> = ({
    signal,
  }) => listRenewals(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRenewals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRenewalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRenewals>>
>;
export type ListRenewalsQueryError = ErrorType<unknown>;

/**
 * @summary List all renewals (including auto-candidates within 12mo of expiry)
 */

export function useListRenewals<
  TData = Awaited<ReturnType<typeof listRenewals>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRenewalsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRenewals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRenewalsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Start a renewal for a contract (adds to pipeline)
 */
export const getStartRenewalUrl = () => {
  return `/api/renewals`;
};

export const startRenewal = async (
  startRenewalBody: StartRenewalBody,
  options?: RequestInit,
): Promise<Renewal> => {
  return customFetch<Renewal>(getStartRenewalUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(startRenewalBody),
  });
};

export const getStartRenewalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startRenewal>>,
    TError,
    { data: BodyType<StartRenewalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startRenewal>>,
  TError,
  { data: BodyType<StartRenewalBody> },
  TContext
> => {
  const mutationKey = ["startRenewal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startRenewal>>,
    { data: BodyType<StartRenewalBody> }
  > = (props) => {
    const { data } = props ?? {};

    return startRenewal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartRenewalMutationResult = NonNullable<
  Awaited<ReturnType<typeof startRenewal>>
>;
export type StartRenewalMutationBody = BodyType<StartRenewalBody>;
export type StartRenewalMutationError = ErrorType<unknown>;

/**
 * @summary Start a renewal for a contract (adds to pipeline)
 */
export const useStartRenewal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startRenewal>>,
    TError,
    { data: BodyType<StartRenewalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startRenewal>>,
  TError,
  { data: BodyType<StartRenewalBody> },
  TContext
> => {
  return useMutation(getStartRenewalMutationOptions(options));
};

/**
 * @summary Update a renewal (stage, assignee, target date, notes)
 */
export const getUpdateRenewalUrl = (id: number) => {
  return `/api/renewals/${id}`;
};

export const updateRenewal = async (
  id: number,
  updateRenewalBody: UpdateRenewalBody,
  options?: RequestInit,
): Promise<Renewal> => {
  return customFetch<Renewal>(getUpdateRenewalUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateRenewalBody),
  });
};

export const getUpdateRenewalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRenewal>>,
    TError,
    { id: number; data: BodyType<UpdateRenewalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRenewal>>,
  TError,
  { id: number; data: BodyType<UpdateRenewalBody> },
  TContext
> => {
  const mutationKey = ["updateRenewal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRenewal>>,
    { id: number; data: BodyType<UpdateRenewalBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateRenewal(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRenewalMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRenewal>>
>;
export type UpdateRenewalMutationBody = BodyType<UpdateRenewalBody>;
export type UpdateRenewalMutationError = ErrorType<unknown>;

/**
 * @summary Update a renewal (stage, assignee, target date, notes)
 */
export const useUpdateRenewal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRenewal>>,
    TError,
    { id: number; data: BodyType<UpdateRenewalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRenewal>>,
  TError,
  { id: number; data: BodyType<UpdateRenewalBody> },
  TContext
> => {
  return useMutation(getUpdateRenewalMutationOptions(options));
};

/**
 * @summary Remove a renewal from the pipeline
 */
export const getDeleteRenewalUrl = (id: number) => {
  return `/api/renewals/${id}`;
};

export const deleteRenewal = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteRenewalUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteRenewalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRenewal>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRenewal>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteRenewal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRenewal>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteRenewal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRenewalMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRenewal>>
>;

export type DeleteRenewalMutationError = ErrorType<unknown>;

/**
 * @summary Remove a renewal from the pipeline
 */
export const useDeleteRenewal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRenewal>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteRenewal>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteRenewalMutationOptions(options));
};

/**
 * @summary List comments for a record
 */
export const getListCommentsUrl = (params: ListCommentsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/comments?${stringifiedParams}`
    : `/api/comments`;
};

export const listComments = async (
  params: ListCommentsParams,
  options?: RequestInit,
): Promise<Comment[]> => {
  return customFetch<Comment[]>(getListCommentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCommentsQueryKey = (params?: ListCommentsParams) => {
  return [`/api/comments`, ...(params ? [params] : [])] as const;
};

export const getListCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listComments>>,
  TError = ErrorType<unknown>,
>(
  params: ListCommentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listComments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCommentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listComments>>> = ({
    signal,
  }) => listComments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listComments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listComments>>
>;
export type ListCommentsQueryError = ErrorType<unknown>;

/**
 * @summary List comments for a record
 */

export function useListComments<
  TData = Awaited<ReturnType<typeof listComments>>,
  TError = ErrorType<unknown>,
>(
  params: ListCommentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listComments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCommentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a comment on a record
 */
export const getCreateCommentUrl = () => {
  return `/api/comments`;
};

export const createComment = async (
  createCommentBody: CreateCommentBody,
  options?: RequestInit,
): Promise<Comment> => {
  return customFetch<Comment>(getCreateCommentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCommentBody),
  });
};

export const getCreateCommentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createComment>>,
    TError,
    { data: BodyType<CreateCommentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createComment>>,
  TError,
  { data: BodyType<CreateCommentBody> },
  TContext
> => {
  const mutationKey = ["createComment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createComment>>,
    { data: BodyType<CreateCommentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createComment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createComment>>
>;
export type CreateCommentMutationBody = BodyType<CreateCommentBody>;
export type CreateCommentMutationError = ErrorType<unknown>;

/**
 * @summary Create a comment on a record
 */
export const useCreateComment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createComment>>,
    TError,
    { data: BodyType<CreateCommentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createComment>>,
  TError,
  { data: BodyType<CreateCommentBody> },
  TContext
> => {
  return useMutation(getCreateCommentMutationOptions(options));
};

/**
 * @summary Edit a comment (author only)
 */
export const getUpdateCommentUrl = (id: number) => {
  return `/api/comments/${id}`;
};

export const updateComment = async (
  id: number,
  updateCommentBody: UpdateCommentBody,
  options?: RequestInit,
): Promise<Comment> => {
  return customFetch<Comment>(getUpdateCommentUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCommentBody),
  });
};

export const getUpdateCommentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateComment>>,
    TError,
    { id: number; data: BodyType<UpdateCommentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateComment>>,
  TError,
  { id: number; data: BodyType<UpdateCommentBody> },
  TContext
> => {
  const mutationKey = ["updateComment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateComment>>,
    { id: number; data: BodyType<UpdateCommentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateComment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateComment>>
>;
export type UpdateCommentMutationBody = BodyType<UpdateCommentBody>;
export type UpdateCommentMutationError = ErrorType<unknown>;

/**
 * @summary Edit a comment (author only)
 */
export const useUpdateComment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateComment>>,
    TError,
    { id: number; data: BodyType<UpdateCommentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateComment>>,
  TError,
  { id: number; data: BodyType<UpdateCommentBody> },
  TContext
> => {
  return useMutation(getUpdateCommentMutationOptions(options));
};

/**
 * @summary Delete a comment (author only)
 */
export const getDeleteCommentUrl = (id: number) => {
  return `/api/comments/${id}`;
};

export const deleteComment = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCommentUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCommentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteComment>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteComment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteComment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteComment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteComment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteComment>>
>;

export type DeleteCommentMutationError = ErrorType<unknown>;

/**
 * @summary Delete a comment (author only)
 */
export const useDeleteComment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteComment>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteComment>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCommentMutationOptions(options));
};

/**
 * @summary List mentions for the current user
 */
export const getListMyMentionsUrl = (params?: ListMyMentionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/mentions?${stringifiedParams}`
    : `/api/mentions`;
};

export const listMyMentions = async (
  params?: ListMyMentionsParams,
  options?: RequestInit,
): Promise<MentionItem[]> => {
  return customFetch<MentionItem[]>(getListMyMentionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMyMentionsQueryKey = (params?: ListMyMentionsParams) => {
  return [`/api/mentions`, ...(params ? [params] : [])] as const;
};

export const getListMyMentionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyMentions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMyMentionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMyMentions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyMentionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyMentions>>> = ({
    signal,
  }) => listMyMentions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyMentions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyMentionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyMentions>>
>;
export type ListMyMentionsQueryError = ErrorType<unknown>;

/**
 * @summary List mentions for the current user
 */

export function useListMyMentions<
  TData = Awaited<ReturnType<typeof listMyMentions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMyMentionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMyMentions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyMentionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark mentions as read
 */
export const getMarkMentionsReadUrl = () => {
  return `/api/mentions/read`;
};

export const markMentionsRead = async (
  markMentionsReadBody: MarkMentionsReadBody,
  options?: RequestInit,
): Promise<MarkMentionsReadResponse> => {
  return customFetch<MarkMentionsReadResponse>(getMarkMentionsReadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(markMentionsReadBody),
  });
};

export const getMarkMentionsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMentionsRead>>,
    TError,
    { data: BodyType<MarkMentionsReadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markMentionsRead>>,
  TError,
  { data: BodyType<MarkMentionsReadBody> },
  TContext
> => {
  const mutationKey = ["markMentionsRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markMentionsRead>>,
    { data: BodyType<MarkMentionsReadBody> }
  > = (props) => {
    const { data } = props ?? {};

    return markMentionsRead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkMentionsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markMentionsRead>>
>;
export type MarkMentionsReadMutationBody = BodyType<MarkMentionsReadBody>;
export type MarkMentionsReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark mentions as read
 */
export const useMarkMentionsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMentionsRead>>,
    TError,
    { data: BodyType<MarkMentionsReadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markMentionsRead>>,
  TError,
  { data: BodyType<MarkMentionsReadBody> },
  TContext
> => {
  return useMutation(getMarkMentionsReadMutationOptions(options));
};

/**
 * @summary List all members in the current org
 */
export const getListTeamMembersUrl = () => {
  return `/api/team/members`;
};

export const listTeamMembers = async (
  options?: RequestInit,
): Promise<TeamMember[]> => {
  return customFetch<TeamMember[]>(getListTeamMembersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTeamMembersQueryKey = () => {
  return [`/api/team/members`] as const;
};

export const getListTeamMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listTeamMembers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTeamMembers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTeamMembersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamMembers>>> = ({
    signal,
  }) => listTeamMembers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTeamMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTeamMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeamMembers>>
>;
export type ListTeamMembersQueryError = ErrorType<unknown>;

/**
 * @summary List all members in the current org
 */

export function useListTeamMembers<
  TData = Awaited<ReturnType<typeof listTeamMembers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTeamMembers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTeamMembersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Set persona roles for a team member (admin only)
 */
export const getUpdateMemberPersonasUrl = (memberId: string) => {
  return `/api/team/members/${memberId}/personas`;
};

export const updateMemberPersonas = async (
  memberId: string,
  updateMemberPersonasBody: UpdateMemberPersonasBody,
  options?: RequestInit,
): Promise<UpdateMemberPersonasResponse> => {
  return customFetch<UpdateMemberPersonasResponse>(
    getUpdateMemberPersonasUrl(memberId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateMemberPersonasBody),
    },
  );
};

export const getUpdateMemberPersonasMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemberPersonas>>,
    TError,
    { memberId: string; data: BodyType<UpdateMemberPersonasBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMemberPersonas>>,
  TError,
  { memberId: string; data: BodyType<UpdateMemberPersonasBody> },
  TContext
> => {
  const mutationKey = ["updateMemberPersonas"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMemberPersonas>>,
    { memberId: string; data: BodyType<UpdateMemberPersonasBody> }
  > = (props) => {
    const { memberId, data } = props ?? {};

    return updateMemberPersonas(memberId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMemberPersonasMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMemberPersonas>>
>;
export type UpdateMemberPersonasMutationBody =
  BodyType<UpdateMemberPersonasBody>;
export type UpdateMemberPersonasMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Set persona roles for a team member (admin only)
 */
export const useUpdateMemberPersonas = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemberPersonas>>,
    TError,
    { memberId: string; data: BodyType<UpdateMemberPersonasBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMemberPersonas>>,
  TError,
  { memberId: string; data: BodyType<UpdateMemberPersonasBody> },
  TContext
> => {
  return useMutation(getUpdateMemberPersonasMutationOptions(options));
};

/**
 * @summary List org-wide audit log entries (admin only)
 */
export const getListAuditLogUrl = (params?: ListAuditLogParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/audit-log?${stringifiedParams}`
    : `/api/audit-log`;
};

export const listAuditLog = async (
  params?: ListAuditLogParams,
  options?: RequestInit,
): Promise<AuditLogEntry[]> => {
  return customFetch<AuditLogEntry[]>(getListAuditLogUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAuditLogQueryKey = (params?: ListAuditLogParams) => {
  return [`/api/audit-log`, ...(params ? [params] : [])] as const;
};

export const getListAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof listAuditLog>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAuditLogQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLog>>> = ({
    signal,
  }) => listAuditLog(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAuditLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAuditLog>>
>;
export type ListAuditLogQueryError = ErrorType<unknown>;

/**
 * @summary List org-wide audit log entries (admin only)
 */

export function useListAuditLog<
  TData = Awaited<ReturnType<typeof listAuditLog>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List available merge fields for clause bodies
 */
export const getListMergeFieldsUrl = () => {
  return `/api/clauses/merge-fields`;
};

export const listMergeFields = async (
  options?: RequestInit,
): Promise<MergeField[]> => {
  return customFetch<MergeField[]>(getListMergeFieldsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMergeFieldsQueryKey = () => {
  return [`/api/clauses/merge-fields`] as const;
};

export const getListMergeFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMergeFields>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMergeFields>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMergeFieldsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMergeFields>>> = ({
    signal,
  }) => listMergeFields({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMergeFields>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMergeFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMergeFields>>
>;
export type ListMergeFieldsQueryError = ErrorType<unknown>;

/**
 * @summary List available merge fields for clause bodies
 */

export function useListMergeFields<
  TData = Awaited<ReturnType<typeof listMergeFields>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMergeFields>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMergeFieldsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all clauses in the org library
 */
export const getListClausesUrl = (params?: ListClausesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/clauses?${stringifiedParams}`
    : `/api/clauses`;
};

export const listClauses = async (
  params?: ListClausesParams,
  options?: RequestInit,
): Promise<Clause[]> => {
  return customFetch<Clause[]>(getListClausesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListClausesQueryKey = (params?: ListClausesParams) => {
  return [`/api/clauses`, ...(params ? [params] : [])] as const;
};

export const getListClausesQueryOptions = <
  TData = Awaited<ReturnType<typeof listClauses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClausesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClauses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListClausesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listClauses>>> = ({
    signal,
  }) => listClauses(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listClauses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListClausesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClauses>>
>;
export type ListClausesQueryError = ErrorType<unknown>;

/**
 * @summary List all clauses in the org library
 */

export function useListClauses<
  TData = Awaited<ReturnType<typeof listClauses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClausesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClauses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListClausesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new clause with initial version
 */
export const getCreateClauseUrl = () => {
  return `/api/clauses`;
};

export const createClause = async (
  createClauseBody: CreateClauseBody,
  options?: RequestInit,
): Promise<Clause> => {
  return customFetch<Clause>(getCreateClauseUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createClauseBody),
  });
};

export const getCreateClauseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClause>>,
    TError,
    { data: BodyType<CreateClauseBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClause>>,
  TError,
  { data: BodyType<CreateClauseBody> },
  TContext
> => {
  const mutationKey = ["createClause"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClause>>,
    { data: BodyType<CreateClauseBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createClause(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClause>>
>;
export type CreateClauseMutationBody = BodyType<CreateClauseBody>;
export type CreateClauseMutationError = ErrorType<unknown>;

/**
 * @summary Create a new clause with initial version
 */
export const useCreateClause = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClause>>,
    TError,
    { data: BodyType<CreateClauseBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createClause>>,
  TError,
  { data: BodyType<CreateClauseBody> },
  TContext
> => {
  return useMutation(getCreateClauseMutationOptions(options));
};

/**
 * @summary Get a clause with all versions
 */
export const getGetClauseUrl = (id: number) => {
  return `/api/clauses/${id}`;
};

export const getClause = async (
  id: number,
  options?: RequestInit,
): Promise<ClauseDetail> => {
  return customFetch<ClauseDetail>(getGetClauseUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetClauseQueryKey = (id: number) => {
  return [`/api/clauses/${id}`] as const;
};

export const getGetClauseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClause>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClause>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClauseQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClause>>> = ({
    signal,
  }) => getClause(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getClause>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetClauseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClause>>
>;
export type GetClauseQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a clause with all versions
 */

export function useGetClause<
  TData = Awaited<ReturnType<typeof getClause>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClause>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetClauseQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update clause metadata (does not create new version)
 */
export const getUpdateClauseUrl = (id: number) => {
  return `/api/clauses/${id}`;
};

export const updateClause = async (
  id: number,
  updateClauseBody: UpdateClauseBody,
  options?: RequestInit,
): Promise<Clause> => {
  return customFetch<Clause>(getUpdateClauseUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateClauseBody),
  });
};

export const getUpdateClauseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClause>>,
    TError,
    { id: number; data: BodyType<UpdateClauseBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClause>>,
  TError,
  { id: number; data: BodyType<UpdateClauseBody> },
  TContext
> => {
  const mutationKey = ["updateClause"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClause>>,
    { id: number; data: BodyType<UpdateClauseBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateClause(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClause>>
>;
export type UpdateClauseMutationBody = BodyType<UpdateClauseBody>;
export type UpdateClauseMutationError = ErrorType<unknown>;

/**
 * @summary Update clause metadata (does not create new version)
 */
export const useUpdateClause = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClause>>,
    TError,
    { id: number; data: BodyType<UpdateClauseBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateClause>>,
  TError,
  { id: number; data: BodyType<UpdateClauseBody> },
  TContext
> => {
  return useMutation(getUpdateClauseMutationOptions(options));
};

/**
 * @summary Delete a clause (fails if used in contracts)
 */
export const getDeleteClauseUrl = (id: number) => {
  return `/api/clauses/${id}`;
};

export const deleteClause = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteClauseUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteClauseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClause>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClause>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteClause"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClause>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteClause(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClause>>
>;

export type DeleteClauseMutationError = ErrorType<unknown>;

/**
 * @summary Delete a clause (fails if used in contracts)
 */
export const useDeleteClause = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClause>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteClause>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteClauseMutationOptions(options));
};

/**
 * @summary Add a new version to a clause
 */
export const getAddClauseVersionUrl = (id: number) => {
  return `/api/clauses/${id}/versions`;
};

export const addClauseVersion = async (
  id: number,
  addClauseVersionBody: AddClauseVersionBody,
  options?: RequestInit,
): Promise<ClauseVersion> => {
  return customFetch<ClauseVersion>(getAddClauseVersionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addClauseVersionBody),
  });
};

export const getAddClauseVersionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addClauseVersion>>,
    TError,
    { id: number; data: BodyType<AddClauseVersionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addClauseVersion>>,
  TError,
  { id: number; data: BodyType<AddClauseVersionBody> },
  TContext
> => {
  const mutationKey = ["addClauseVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addClauseVersion>>,
    { id: number; data: BodyType<AddClauseVersionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addClauseVersion(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddClauseVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof addClauseVersion>>
>;
export type AddClauseVersionMutationBody = BodyType<AddClauseVersionBody>;
export type AddClauseVersionMutationError = ErrorType<unknown>;

/**
 * @summary Add a new version to a clause
 */
export const useAddClauseVersion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addClauseVersion>>,
    TError,
    { id: number; data: BodyType<AddClauseVersionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addClauseVersion>>,
  TError,
  { id: number; data: BodyType<AddClauseVersionBody> },
  TContext
> => {
  return useMutation(getAddClauseVersionMutationOptions(options));
};

/**
 * @summary List clauses attached to a contract
 */
export const getListContractClausesUrl = (contractId: number) => {
  return `/api/contracts/${contractId}/clauses`;
};

export const listContractClauses = async (
  contractId: number,
  options?: RequestInit,
): Promise<ContractClause[]> => {
  return customFetch<ContractClause[]>(getListContractClausesUrl(contractId), {
    ...options,
    method: "GET",
  });
};

export const getListContractClausesQueryKey = (contractId: number) => {
  return [`/api/contracts/${contractId}/clauses`] as const;
};

export const getListContractClausesQueryOptions = <
  TData = Awaited<ReturnType<typeof listContractClauses>>,
  TError = ErrorType<unknown>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractClauses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListContractClausesQueryKey(contractId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContractClauses>>
  > = ({ signal }) =>
    listContractClauses(contractId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!contractId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listContractClauses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContractClausesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContractClauses>>
>;
export type ListContractClausesQueryError = ErrorType<unknown>;

/**
 * @summary List clauses attached to a contract
 */

export function useListContractClauses<
  TData = Awaited<ReturnType<typeof listContractClauses>>,
  TError = ErrorType<unknown>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractClauses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContractClausesQueryOptions(contractId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Attach a clause (specific version) to a contract
 */
export const getAddContractClauseUrl = (contractId: number) => {
  return `/api/contracts/${contractId}/clauses`;
};

export const addContractClause = async (
  contractId: number,
  addContractClauseBody: AddContractClauseBody,
  options?: RequestInit,
): Promise<ContractClause> => {
  return customFetch<ContractClause>(getAddContractClauseUrl(contractId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addContractClauseBody),
  });
};

export const getAddContractClauseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addContractClause>>,
    TError,
    { contractId: number; data: BodyType<AddContractClauseBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addContractClause>>,
  TError,
  { contractId: number; data: BodyType<AddContractClauseBody> },
  TContext
> => {
  const mutationKey = ["addContractClause"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addContractClause>>,
    { contractId: number; data: BodyType<AddContractClauseBody> }
  > = (props) => {
    const { contractId, data } = props ?? {};

    return addContractClause(contractId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddContractClauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof addContractClause>>
>;
export type AddContractClauseMutationBody = BodyType<AddContractClauseBody>;
export type AddContractClauseMutationError = ErrorType<unknown>;

/**
 * @summary Attach a clause (specific version) to a contract
 */
export const useAddContractClause = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addContractClause>>,
    TError,
    { contractId: number; data: BodyType<AddContractClauseBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addContractClause>>,
  TError,
  { contractId: number; data: BodyType<AddContractClauseBody> },
  TContext
> => {
  return useMutation(getAddContractClauseMutationOptions(options));
};

/**
 * @summary Reorder clauses on a contract
 */
export const getReorderContractClausesUrl = (contractId: number) => {
  return `/api/contracts/${contractId}/clauses/reorder`;
};

export const reorderContractClauses = async (
  contractId: number,
  reorderContractClausesBody: ReorderContractClausesBody,
  options?: RequestInit,
): Promise<ReorderContractClauses200> => {
  return customFetch<ReorderContractClauses200>(
    getReorderContractClausesUrl(contractId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(reorderContractClausesBody),
    },
  );
};

export const getReorderContractClausesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderContractClauses>>,
    TError,
    { contractId: number; data: BodyType<ReorderContractClausesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderContractClauses>>,
  TError,
  { contractId: number; data: BodyType<ReorderContractClausesBody> },
  TContext
> => {
  const mutationKey = ["reorderContractClauses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderContractClauses>>,
    { contractId: number; data: BodyType<ReorderContractClausesBody> }
  > = (props) => {
    const { contractId, data } = props ?? {};

    return reorderContractClauses(contractId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderContractClausesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderContractClauses>>
>;
export type ReorderContractClausesMutationBody =
  BodyType<ReorderContractClausesBody>;
export type ReorderContractClausesMutationError = ErrorType<unknown>;

/**
 * @summary Reorder clauses on a contract
 */
export const useReorderContractClauses = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderContractClauses>>,
    TError,
    { contractId: number; data: BodyType<ReorderContractClausesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderContractClauses>>,
  TError,
  { contractId: number; data: BodyType<ReorderContractClausesBody> },
  TContext
> => {
  return useMutation(getReorderContractClausesMutationOptions(options));
};

/**
 * @summary Remove a clause from a contract
 */
export const getRemoveContractClauseUrl = (contractId: number, id: number) => {
  return `/api/contracts/${contractId}/clauses/${id}`;
};

export const removeContractClause = async (
  contractId: number,
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRemoveContractClauseUrl(contractId, id), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveContractClauseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeContractClause>>,
    TError,
    { contractId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeContractClause>>,
  TError,
  { contractId: number; id: number },
  TContext
> => {
  const mutationKey = ["removeContractClause"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeContractClause>>,
    { contractId: number; id: number }
  > = (props) => {
    const { contractId, id } = props ?? {};

    return removeContractClause(contractId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveContractClauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeContractClause>>
>;

export type RemoveContractClauseMutationError = ErrorType<unknown>;

/**
 * @summary Remove a clause from a contract
 */
export const useRemoveContractClause = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeContractClause>>,
    TError,
    { contractId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeContractClause>>,
  TError,
  { contractId: number; id: number },
  TContext
> => {
  return useMutation(getRemoveContractClauseMutationOptions(options));
};

/**
 * @summary List per-contract clause overrides
 */
export const getListContractClauseOverridesUrl = (contractId: number) => {
  return `/api/contracts/${contractId}/clause-overrides`;
};

export const listContractClauseOverrides = async (
  contractId: number,
  options?: RequestInit,
): Promise<ContractClauseOverride[]> => {
  return customFetch<ContractClauseOverride[]>(
    getListContractClauseOverridesUrl(contractId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListContractClauseOverridesQueryKey = (contractId: number) => {
  return [`/api/contracts/${contractId}/clause-overrides`] as const;
};

export const getListContractClauseOverridesQueryOptions = <
  TData = Awaited<ReturnType<typeof listContractClauseOverrides>>,
  TError = ErrorType<ErrorResponse>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractClauseOverrides>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListContractClauseOverridesQueryKey(contractId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContractClauseOverrides>>
  > = ({ signal }) =>
    listContractClauseOverrides(contractId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!contractId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listContractClauseOverrides>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContractClauseOverridesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContractClauseOverrides>>
>;
export type ListContractClauseOverridesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List per-contract clause overrides
 */

export function useListContractClauseOverrides<
  TData = Awaited<ReturnType<typeof listContractClauseOverrides>>,
  TError = ErrorType<ErrorResponse>,
>(
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractClauseOverrides>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContractClauseOverridesQueryOptions(
    contractId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or update a per-contract clause override
 */
export const getUpsertContractClauseOverrideUrl = (
  contractId: number,
  contractClauseId: number,
) => {
  return `/api/contracts/${contractId}/clause-overrides/${contractClauseId}`;
};

export const upsertContractClauseOverride = async (
  contractId: number,
  contractClauseId: number,
  upsertContractClauseOverrideBody: UpsertContractClauseOverrideBody,
  options?: RequestInit,
): Promise<ContractClauseOverride> => {
  return customFetch<ContractClauseOverride>(
    getUpsertContractClauseOverrideUrl(contractId, contractClauseId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(upsertContractClauseOverrideBody),
    },
  );
};

export const getUpsertContractClauseOverrideMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertContractClauseOverride>>,
    TError,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<UpsertContractClauseOverrideBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertContractClauseOverride>>,
  TError,
  {
    contractId: number;
    contractClauseId: number;
    data: BodyType<UpsertContractClauseOverrideBody>;
  },
  TContext
> => {
  const mutationKey = ["upsertContractClauseOverride"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertContractClauseOverride>>,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<UpsertContractClauseOverrideBody>;
    }
  > = (props) => {
    const { contractId, contractClauseId, data } = props ?? {};

    return upsertContractClauseOverride(
      contractId,
      contractClauseId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertContractClauseOverrideMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertContractClauseOverride>>
>;
export type UpsertContractClauseOverrideMutationBody =
  BodyType<UpsertContractClauseOverrideBody>;
export type UpsertContractClauseOverrideMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Create or update a per-contract clause override
 */
export const useUpsertContractClauseOverride = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertContractClauseOverride>>,
    TError,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<UpsertContractClauseOverrideBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertContractClauseOverride>>,
  TError,
  {
    contractId: number;
    contractClauseId: number;
    data: BodyType<UpsertContractClauseOverrideBody>;
  },
  TContext
> => {
  return useMutation(getUpsertContractClauseOverrideMutationOptions(options));
};

/**
 * @summary Remove a per-contract clause override (revert to library version)
 */
export const getRevertContractClauseOverrideUrl = (
  contractId: number,
  contractClauseId: number,
) => {
  return `/api/contracts/${contractId}/clause-overrides/${contractClauseId}`;
};

export const revertContractClauseOverride = async (
  contractId: number,
  contractClauseId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(
    getRevertContractClauseOverrideUrl(contractId, contractClauseId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRevertContractClauseOverrideMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertContractClauseOverride>>,
    TError,
    { contractId: number; contractClauseId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revertContractClauseOverride>>,
  TError,
  { contractId: number; contractClauseId: number },
  TContext
> => {
  const mutationKey = ["revertContractClauseOverride"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revertContractClauseOverride>>,
    { contractId: number; contractClauseId: number }
  > = (props) => {
    const { contractId, contractClauseId } = props ?? {};

    return revertContractClauseOverride(
      contractId,
      contractClauseId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RevertContractClauseOverrideMutationResult = NonNullable<
  Awaited<ReturnType<typeof revertContractClauseOverride>>
>;

export type RevertContractClauseOverrideMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Remove a per-contract clause override (revert to library version)
 */
export const useRevertContractClauseOverride = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertContractClauseOverride>>,
    TError,
    { contractId: number; contractClauseId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revertContractClauseOverride>>,
  TError,
  { contractId: number; contractClauseId: number },
  TContext
> => {
  return useMutation(getRevertContractClauseOverrideMutationOptions(options));
};

/**
 * @summary Lock or unlock a clause override
 */
export const getLockContractClauseOverrideUrl = (
  contractId: number,
  contractClauseId: number,
) => {
  return `/api/contracts/${contractId}/clause-overrides/${contractClauseId}/lock`;
};

export const lockContractClauseOverride = async (
  contractId: number,
  contractClauseId: number,
  lockContractClauseOverrideBody: LockContractClauseOverrideBody,
  options?: RequestInit,
): Promise<ContractClauseOverride> => {
  return customFetch<ContractClauseOverride>(
    getLockContractClauseOverrideUrl(contractId, contractClauseId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(lockContractClauseOverrideBody),
    },
  );
};

export const getLockContractClauseOverrideMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockContractClauseOverride>>,
    TError,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<LockContractClauseOverrideBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lockContractClauseOverride>>,
  TError,
  {
    contractId: number;
    contractClauseId: number;
    data: BodyType<LockContractClauseOverrideBody>;
  },
  TContext
> => {
  const mutationKey = ["lockContractClauseOverride"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lockContractClauseOverride>>,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<LockContractClauseOverrideBody>;
    }
  > = (props) => {
    const { contractId, contractClauseId, data } = props ?? {};

    return lockContractClauseOverride(
      contractId,
      contractClauseId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type LockContractClauseOverrideMutationResult = NonNullable<
  Awaited<ReturnType<typeof lockContractClauseOverride>>
>;
export type LockContractClauseOverrideMutationBody =
  BodyType<LockContractClauseOverrideBody>;
export type LockContractClauseOverrideMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Lock or unlock a clause override
 */
export const useLockContractClauseOverride = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockContractClauseOverride>>,
    TError,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<LockContractClauseOverrideBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lockContractClauseOverride>>,
  TError,
  {
    contractId: number;
    contractClauseId: number;
    data: BodyType<LockContractClauseOverrideBody>;
  },
  TContext
> => {
  return useMutation(getLockContractClauseOverrideMutationOptions(options));
};

/**
 * @summary Propose alternate language for a clause on this contract
 */
export const getProposeContractClauseAlternateUrl = (
  contractId: number,
  contractClauseId: number,
) => {
  return `/api/contracts/${contractId}/clause-overrides/${contractClauseId}/alternate`;
};

export const proposeContractClauseAlternate = async (
  contractId: number,
  contractClauseId: number,
  proposeContractClauseAlternateBody: ProposeContractClauseAlternateBody,
  options?: RequestInit,
): Promise<ContractClauseOverride> => {
  return customFetch<ContractClauseOverride>(
    getProposeContractClauseAlternateUrl(contractId, contractClauseId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(proposeContractClauseAlternateBody),
    },
  );
};

export const getProposeContractClauseAlternateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proposeContractClauseAlternate>>,
    TError,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<ProposeContractClauseAlternateBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof proposeContractClauseAlternate>>,
  TError,
  {
    contractId: number;
    contractClauseId: number;
    data: BodyType<ProposeContractClauseAlternateBody>;
  },
  TContext
> => {
  const mutationKey = ["proposeContractClauseAlternate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof proposeContractClauseAlternate>>,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<ProposeContractClauseAlternateBody>;
    }
  > = (props) => {
    const { contractId, contractClauseId, data } = props ?? {};

    return proposeContractClauseAlternate(
      contractId,
      contractClauseId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ProposeContractClauseAlternateMutationResult = NonNullable<
  Awaited<ReturnType<typeof proposeContractClauseAlternate>>
>;
export type ProposeContractClauseAlternateMutationBody =
  BodyType<ProposeContractClauseAlternateBody>;
export type ProposeContractClauseAlternateMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Propose alternate language for a clause on this contract
 */
export const useProposeContractClauseAlternate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proposeContractClauseAlternate>>,
    TError,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<ProposeContractClauseAlternateBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof proposeContractClauseAlternate>>,
  TError,
  {
    contractId: number;
    contractClauseId: number;
    data: BodyType<ProposeContractClauseAlternateBody>;
  },
  TContext
> => {
  return useMutation(getProposeContractClauseAlternateMutationOptions(options));
};

/**
 * @summary Promote a per-contract override to a new library clause version
 */
export const getPromoteContractClauseOverrideToLibraryUrl = (
  contractId: number,
  contractClauseId: number,
) => {
  return `/api/contracts/${contractId}/clause-overrides/${contractClauseId}/promote`;
};

export const promoteContractClauseOverrideToLibrary = async (
  contractId: number,
  contractClauseId: number,
  promoteContractClauseOverrideBody: PromoteContractClauseOverrideBody,
  options?: RequestInit,
): Promise<PromoteContractClauseOverrideResponse> => {
  return customFetch<PromoteContractClauseOverrideResponse>(
    getPromoteContractClauseOverrideToLibraryUrl(contractId, contractClauseId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(promoteContractClauseOverrideBody),
    },
  );
};

export const getPromoteContractClauseOverrideToLibraryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteContractClauseOverrideToLibrary>>,
    TError,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<PromoteContractClauseOverrideBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoteContractClauseOverrideToLibrary>>,
  TError,
  {
    contractId: number;
    contractClauseId: number;
    data: BodyType<PromoteContractClauseOverrideBody>;
  },
  TContext
> => {
  const mutationKey = ["promoteContractClauseOverrideToLibrary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoteContractClauseOverrideToLibrary>>,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<PromoteContractClauseOverrideBody>;
    }
  > = (props) => {
    const { contractId, contractClauseId, data } = props ?? {};

    return promoteContractClauseOverrideToLibrary(
      contractId,
      contractClauseId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoteContractClauseOverrideToLibraryMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoteContractClauseOverrideToLibrary>>
>;
export type PromoteContractClauseOverrideToLibraryMutationBody =
  BodyType<PromoteContractClauseOverrideBody>;
export type PromoteContractClauseOverrideToLibraryMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Promote a per-contract override to a new library clause version
 */
export const usePromoteContractClauseOverrideToLibrary = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteContractClauseOverrideToLibrary>>,
    TError,
    {
      contractId: number;
      contractClauseId: number;
      data: BodyType<PromoteContractClauseOverrideBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoteContractClauseOverrideToLibrary>>,
  TError,
  {
    contractId: number;
    contractClauseId: number;
    data: BodyType<PromoteContractClauseOverrideBody>;
  },
  TContext
> => {
  return useMutation(
    getPromoteContractClauseOverrideToLibraryMutationOptions(options),
  );
};

/**
 * @summary List clause unlock requests across the org (Legal inbox)
 */
export const getListClauseUnlockRequestsUrl = (
  params?: ListClauseUnlockRequestsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/clause-unlock-requests?${stringifiedParams}`
    : `/api/clause-unlock-requests`;
};

export const listClauseUnlockRequests = async (
  params?: ListClauseUnlockRequestsParams,
  options?: RequestInit,
): Promise<ClauseUnlockRequestInboxItem[]> => {
  return customFetch<ClauseUnlockRequestInboxItem[]>(
    getListClauseUnlockRequestsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListClauseUnlockRequestsQueryKey = (
  params?: ListClauseUnlockRequestsParams,
) => {
  return [`/api/clause-unlock-requests`, ...(params ? [params] : [])] as const;
};

export const getListClauseUnlockRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof listClauseUnlockRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClauseUnlockRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClauseUnlockRequests>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListClauseUnlockRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listClauseUnlockRequests>>
  > = ({ signal }) =>
    listClauseUnlockRequests(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listClauseUnlockRequests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListClauseUnlockRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClauseUnlockRequests>>
>;
export type ListClauseUnlockRequestsQueryError = ErrorType<unknown>;

/**
 * @summary List clause unlock requests across the org (Legal inbox)
 */

export function useListClauseUnlockRequests<
  TData = Awaited<ReturnType<typeof listClauseUnlockRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClauseUnlockRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClauseUnlockRequests>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListClauseUnlockRequestsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Count of pending clause unlock requests in the org
 */
export const getGetClauseUnlockRequestPendingCountUrl = () => {
  return `/api/clause-unlock-requests/count`;
};

export const getClauseUnlockRequestPendingCount = async (
  options?: RequestInit,
): Promise<ClauseUnlockRequestPendingCount> => {
  return customFetch<ClauseUnlockRequestPendingCount>(
    getGetClauseUnlockRequestPendingCountUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetClauseUnlockRequestPendingCountQueryKey = () => {
  return [`/api/clause-unlock-requests/count`] as const;
};

export const getGetClauseUnlockRequestPendingCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getClauseUnlockRequestPendingCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getClauseUnlockRequestPendingCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClauseUnlockRequestPendingCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClauseUnlockRequestPendingCount>>
  > = ({ signal }) =>
    getClauseUnlockRequestPendingCount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClauseUnlockRequestPendingCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetClauseUnlockRequestPendingCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClauseUnlockRequestPendingCount>>
>;
export type GetClauseUnlockRequestPendingCountQueryError = ErrorType<unknown>;

/**
 * @summary Count of pending clause unlock requests in the org
 */

export function useGetClauseUnlockRequestPendingCount<
  TData = Awaited<ReturnType<typeof getClauseUnlockRequestPendingCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getClauseUnlockRequestPendingCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetClauseUnlockRequestPendingCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Approve, deny, or cancel a clause unlock request
 */
export const getResolveClauseUnlockRequestUrl = (id: number) => {
  return `/api/clause-unlock-requests/${id}/resolve`;
};

export const resolveClauseUnlockRequest = async (
  id: number,
  resolveClauseUnlockRequestBody: ResolveClauseUnlockRequestBody,
  options?: RequestInit,
): Promise<ClauseUnlockRequest> => {
  return customFetch<ClauseUnlockRequest>(
    getResolveClauseUnlockRequestUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(resolveClauseUnlockRequestBody),
    },
  );
};

export const getResolveClauseUnlockRequestMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveClauseUnlockRequest>>,
    TError,
    { id: number; data: BodyType<ResolveClauseUnlockRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveClauseUnlockRequest>>,
  TError,
  { id: number; data: BodyType<ResolveClauseUnlockRequestBody> },
  TContext
> => {
  const mutationKey = ["resolveClauseUnlockRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveClauseUnlockRequest>>,
    { id: number; data: BodyType<ResolveClauseUnlockRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return resolveClauseUnlockRequest(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveClauseUnlockRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveClauseUnlockRequest>>
>;
export type ResolveClauseUnlockRequestMutationBody =
  BodyType<ResolveClauseUnlockRequestBody>;
export type ResolveClauseUnlockRequestMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Approve, deny, or cancel a clause unlock request
 */
export const useResolveClauseUnlockRequest = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveClauseUnlockRequest>>,
    TError,
    { id: number; data: BodyType<ResolveClauseUnlockRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolveClauseUnlockRequest>>,
  TError,
  { id: number; data: BodyType<ResolveClauseUnlockRequestBody> },
  TContext
> => {
  return useMutation(getResolveClauseUnlockRequestMutationOptions(options));
};

/**
 * @summary List all policy rules in the org
 */
export const getListPolicyRulesUrl = () => {
  return `/api/policy-rules`;
};

export const listPolicyRules = async (
  options?: RequestInit,
): Promise<PolicyRule[]> => {
  return customFetch<PolicyRule[]>(getListPolicyRulesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPolicyRulesQueryKey = () => {
  return [`/api/policy-rules`] as const;
};

export const getListPolicyRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPolicyRules>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPolicyRules>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPolicyRulesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPolicyRules>>> = ({
    signal,
  }) => listPolicyRules({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPolicyRules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPolicyRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPolicyRules>>
>;
export type ListPolicyRulesQueryError = ErrorType<unknown>;

/**
 * @summary List all policy rules in the org
 */

export function useListPolicyRules<
  TData = Awaited<ReturnType<typeof listPolicyRules>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPolicyRules>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPolicyRulesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new policy rule (admin only)
 */
export const getCreatePolicyRuleUrl = () => {
  return `/api/policy-rules`;
};

export const createPolicyRule = async (
  createPolicyRuleBody: CreatePolicyRuleBody,
  options?: RequestInit,
): Promise<PolicyRule> => {
  return customFetch<PolicyRule>(getCreatePolicyRuleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPolicyRuleBody),
  });
};

export const getCreatePolicyRuleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPolicyRule>>,
    TError,
    { data: BodyType<CreatePolicyRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPolicyRule>>,
  TError,
  { data: BodyType<CreatePolicyRuleBody> },
  TContext
> => {
  const mutationKey = ["createPolicyRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPolicyRule>>,
    { data: BodyType<CreatePolicyRuleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPolicyRule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePolicyRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPolicyRule>>
>;
export type CreatePolicyRuleMutationBody = BodyType<CreatePolicyRuleBody>;
export type CreatePolicyRuleMutationError = ErrorType<unknown>;

/**
 * @summary Create a new policy rule (admin only)
 */
export const useCreatePolicyRule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPolicyRule>>,
    TError,
    { data: BodyType<CreatePolicyRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPolicyRule>>,
  TError,
  { data: BodyType<CreatePolicyRuleBody> },
  TContext
> => {
  return useMutation(getCreatePolicyRuleMutationOptions(options));
};

/**
 * @summary Update a policy rule (admin only)
 */
export const getUpdatePolicyRuleUrl = (id: number) => {
  return `/api/policy-rules/${id}`;
};

export const updatePolicyRule = async (
  id: number,
  updatePolicyRuleBody: UpdatePolicyRuleBody,
  options?: RequestInit,
): Promise<PolicyRule> => {
  return customFetch<PolicyRule>(getUpdatePolicyRuleUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePolicyRuleBody),
  });
};

export const getUpdatePolicyRuleMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePolicyRule>>,
    TError,
    { id: number; data: BodyType<UpdatePolicyRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePolicyRule>>,
  TError,
  { id: number; data: BodyType<UpdatePolicyRuleBody> },
  TContext
> => {
  const mutationKey = ["updatePolicyRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePolicyRule>>,
    { id: number; data: BodyType<UpdatePolicyRuleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePolicyRule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePolicyRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePolicyRule>>
>;
export type UpdatePolicyRuleMutationBody = BodyType<UpdatePolicyRuleBody>;
export type UpdatePolicyRuleMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update a policy rule (admin only)
 */
export const useUpdatePolicyRule = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePolicyRule>>,
    TError,
    { id: number; data: BodyType<UpdatePolicyRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePolicyRule>>,
  TError,
  { id: number; data: BodyType<UpdatePolicyRuleBody> },
  TContext
> => {
  return useMutation(getUpdatePolicyRuleMutationOptions(options));
};

/**
 * @summary Delete a policy rule (admin only)
 */
export const getDeletePolicyRuleUrl = (id: number) => {
  return `/api/policy-rules/${id}`;
};

export const deletePolicyRule = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePolicyRuleUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePolicyRuleMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePolicyRule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePolicyRule>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deletePolicyRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePolicyRule>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePolicyRule(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePolicyRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePolicyRule>>
>;

export type DeletePolicyRuleMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a policy rule (admin only)
 */
export const useDeletePolicyRule = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePolicyRule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePolicyRule>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeletePolicyRuleMutationOptions(options));
};

/**
 * @summary Evaluate policy rules and clause inclusion conditions for a contract
 */
export const getGetContractComplianceUrl = (id: number) => {
  return `/api/contracts/${id}/compliance`;
};

export const getContractCompliance = async (
  id: number,
  options?: RequestInit,
): Promise<ComplianceResult> => {
  return customFetch<ComplianceResult>(getGetContractComplianceUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContractComplianceQueryKey = (id: number) => {
  return [`/api/contracts/${id}/compliance`] as const;
};

export const getGetContractComplianceQueryOptions = <
  TData = Awaited<ReturnType<typeof getContractCompliance>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContractCompliance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetContractComplianceQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContractCompliance>>
  > = ({ signal }) => getContractCompliance(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContractCompliance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContractComplianceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContractCompliance>>
>;
export type GetContractComplianceQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Evaluate policy rules and clause inclusion conditions for a contract
 */

export function useGetContractCompliance<
  TData = Awaited<ReturnType<typeof getContractCompliance>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContractCompliance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContractComplianceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Dismiss an optional clause suggestion with a required reason
 */
export const getDismissClauseSuggestionUrl = (id: number) => {
  return `/api/contracts/${id}/compliance/dismiss-clause`;
};

export const dismissClauseSuggestion = async (
  id: number,
  dismissClauseSuggestionBody: DismissClauseSuggestionBody,
  options?: RequestInit,
): Promise<PolicySuggestionDismissal> => {
  return customFetch<PolicySuggestionDismissal>(
    getDismissClauseSuggestionUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(dismissClauseSuggestionBody),
    },
  );
};

export const getDismissClauseSuggestionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissClauseSuggestion>>,
    TError,
    { id: number; data: BodyType<DismissClauseSuggestionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissClauseSuggestion>>,
  TError,
  { id: number; data: BodyType<DismissClauseSuggestionBody> },
  TContext
> => {
  const mutationKey = ["dismissClauseSuggestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissClauseSuggestion>>,
    { id: number; data: BodyType<DismissClauseSuggestionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dismissClauseSuggestion(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissClauseSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissClauseSuggestion>>
>;
export type DismissClauseSuggestionMutationBody =
  BodyType<DismissClauseSuggestionBody>;
export type DismissClauseSuggestionMutationError = ErrorType<unknown>;

/**
 * @summary Dismiss an optional clause suggestion with a required reason
 */
export const useDismissClauseSuggestion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissClauseSuggestion>>,
    TError,
    { id: number; data: BodyType<DismissClauseSuggestionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissClauseSuggestion>>,
  TError,
  { id: number; data: BodyType<DismissClauseSuggestionBody> },
  TContext
> => {
  return useMutation(getDismissClauseSuggestionMutationOptions(options));
};

/**
 * @summary List all contract templates for the org
 */
export const getListContractTemplatesUrl = (
  params?: ListContractTemplatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/contract-templates?${stringifiedParams}`
    : `/api/contract-templates`;
};

export const listContractTemplates = async (
  params?: ListContractTemplatesParams,
  options?: RequestInit,
): Promise<ContractTemplate[]> => {
  return customFetch<ContractTemplate[]>(getListContractTemplatesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListContractTemplatesQueryKey = (
  params?: ListContractTemplatesParams,
) => {
  return [`/api/contract-templates`, ...(params ? [params] : [])] as const;
};

export const getListContractTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listContractTemplates>>,
  TError = ErrorType<unknown>,
>(
  params?: ListContractTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListContractTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContractTemplates>>
  > = ({ signal }) =>
    listContractTemplates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContractTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContractTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContractTemplates>>
>;
export type ListContractTemplatesQueryError = ErrorType<unknown>;

/**
 * @summary List all contract templates for the org
 */

export function useListContractTemplates<
  TData = Awaited<ReturnType<typeof listContractTemplates>>,
  TError = ErrorType<unknown>,
>(
  params?: ListContractTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContractTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContractTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new contract template
 */
export const getCreateContractTemplateUrl = () => {
  return `/api/contract-templates`;
};

export const createContractTemplate = async (
  createContractTemplateBody: CreateContractTemplateBody,
  options?: RequestInit,
): Promise<ContractTemplate> => {
  return customFetch<ContractTemplate>(getCreateContractTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createContractTemplateBody),
  });
};

export const getCreateContractTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContractTemplate>>,
    TError,
    { data: BodyType<CreateContractTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContractTemplate>>,
  TError,
  { data: BodyType<CreateContractTemplateBody> },
  TContext
> => {
  const mutationKey = ["createContractTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContractTemplate>>,
    { data: BodyType<CreateContractTemplateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createContractTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateContractTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContractTemplate>>
>;
export type CreateContractTemplateMutationBody =
  BodyType<CreateContractTemplateBody>;
export type CreateContractTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Create a new contract template
 */
export const useCreateContractTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContractTemplate>>,
    TError,
    { data: BodyType<CreateContractTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createContractTemplate>>,
  TError,
  { data: BodyType<CreateContractTemplateBody> },
  TContext
> => {
  return useMutation(getCreateContractTemplateMutationOptions(options));
};

/**
 * @summary Get a contract template by ID
 */
export const getGetContractTemplateUrl = (id: number) => {
  return `/api/contract-templates/${id}`;
};

export const getContractTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<ContractTemplate> => {
  return customFetch<ContractTemplate>(getGetContractTemplateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContractTemplateQueryKey = (id: number) => {
  return [`/api/contract-templates/${id}`] as const;
};

export const getGetContractTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getContractTemplate>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContractTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContractTemplateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContractTemplate>>
  > = ({ signal }) => getContractTemplate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContractTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContractTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContractTemplate>>
>;
export type GetContractTemplateQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a contract template by ID
 */

export function useGetContractTemplate<
  TData = Awaited<ReturnType<typeof getContractTemplate>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContractTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContractTemplateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a contract template
 */
export const getUpdateContractTemplateUrl = (id: number) => {
  return `/api/contract-templates/${id}`;
};

export const updateContractTemplate = async (
  id: number,
  updateContractTemplateBody: UpdateContractTemplateBody,
  options?: RequestInit,
): Promise<ContractTemplate> => {
  return customFetch<ContractTemplate>(getUpdateContractTemplateUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateContractTemplateBody),
  });
};

export const getUpdateContractTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContractTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateContractTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContractTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateContractTemplateBody> },
  TContext
> => {
  const mutationKey = ["updateContractTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContractTemplate>>,
    { id: number; data: BodyType<UpdateContractTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateContractTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateContractTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateContractTemplate>>
>;
export type UpdateContractTemplateMutationBody =
  BodyType<UpdateContractTemplateBody>;
export type UpdateContractTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Update a contract template
 */
export const useUpdateContractTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContractTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateContractTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateContractTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateContractTemplateBody> },
  TContext
> => {
  return useMutation(getUpdateContractTemplateMutationOptions(options));
};

/**
 * @summary Delete a contract template
 */
export const getDeleteContractTemplateUrl = (id: number) => {
  return `/api/contract-templates/${id}`;
};

export const deleteContractTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteContractTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteContractTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContractTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContractTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteContractTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContractTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteContractTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContractTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContractTemplate>>
>;

export type DeleteContractTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Delete a contract template
 */
export const useDeleteContractTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContractTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteContractTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteContractTemplateMutationOptions(options));
};

/**
 * @summary Clone a contract template
 */
export const getCloneContractTemplateUrl = (id: number) => {
  return `/api/contract-templates/${id}/clone`;
};

export const cloneContractTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<ContractTemplate> => {
  return customFetch<ContractTemplate>(getCloneContractTemplateUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getCloneContractTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneContractTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneContractTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["cloneContractTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneContractTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return cloneContractTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneContractTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof cloneContractTemplate>>
>;

export type CloneContractTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Clone a contract template
 */
export const useCloneContractTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneContractTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cloneContractTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getCloneContractTemplateMutationOptions(options));
};

/**
 * @summary Create a draft contract from a template
 */
export const getInstantiateContractTemplateUrl = (id: number) => {
  return `/api/contract-templates/${id}/instantiate`;
};

export const instantiateContractTemplate = async (
  id: number,
  instantiateContractTemplateBody: InstantiateContractTemplateBody,
  options?: RequestInit,
): Promise<InstantiateContractTemplateResponse> => {
  return customFetch<InstantiateContractTemplateResponse>(
    getInstantiateContractTemplateUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(instantiateContractTemplateBody),
    },
  );
};

export const getInstantiateContractTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof instantiateContractTemplate>>,
    TError,
    { id: number; data: BodyType<InstantiateContractTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof instantiateContractTemplate>>,
  TError,
  { id: number; data: BodyType<InstantiateContractTemplateBody> },
  TContext
> => {
  const mutationKey = ["instantiateContractTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof instantiateContractTemplate>>,
    { id: number; data: BodyType<InstantiateContractTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return instantiateContractTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InstantiateContractTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof instantiateContractTemplate>>
>;
export type InstantiateContractTemplateMutationBody =
  BodyType<InstantiateContractTemplateBody>;
export type InstantiateContractTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Create a draft contract from a template
 */
export const useInstantiateContractTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof instantiateContractTemplate>>,
    TError,
    { id: number; data: BodyType<InstantiateContractTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof instantiateContractTemplate>>,
  TError,
  { id: number; data: BodyType<InstantiateContractTemplateBody> },
  TContext
> => {
  return useMutation(getInstantiateContractTemplateMutationOptions(options));
};

/**
 * @summary List all risk mitigation items
 */
export const getListMitigationsUrl = (params?: ListMitigationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/mitigations?${stringifiedParams}`
    : `/api/mitigations`;
};

export const listMitigations = async (
  params?: ListMitigationsParams,
  options?: RequestInit,
): Promise<Mitigation[]> => {
  return customFetch<Mitigation[]>(getListMitigationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMitigationsQueryKey = (params?: ListMitigationsParams) => {
  return [`/api/mitigations`, ...(params ? [params] : [])] as const;
};

export const getListMitigationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMitigations>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMitigationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMitigations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMitigationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMitigations>>> = ({
    signal,
  }) => listMitigations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMitigations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMitigationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMitigations>>
>;
export type ListMitigationsQueryError = ErrorType<unknown>;

/**
 * @summary List all risk mitigation items
 */

export function useListMitigations<
  TData = Awaited<ReturnType<typeof listMitigations>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMitigationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMitigations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMitigationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new mitigation item
 */
export const getCreateMitigationUrl = () => {
  return `/api/mitigations`;
};

export const createMitigation = async (
  createMitigationBody: CreateMitigationBody,
  options?: RequestInit,
): Promise<Mitigation> => {
  return customFetch<Mitigation>(getCreateMitigationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMitigationBody),
  });
};

export const getCreateMitigationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMitigation>>,
    TError,
    { data: BodyType<CreateMitigationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMitigation>>,
  TError,
  { data: BodyType<CreateMitigationBody> },
  TContext
> => {
  const mutationKey = ["createMitigation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMitigation>>,
    { data: BodyType<CreateMitigationBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMitigation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMitigationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMitigation>>
>;
export type CreateMitigationMutationBody = BodyType<CreateMitigationBody>;
export type CreateMitigationMutationError = ErrorType<unknown>;

/**
 * @summary Create a new mitigation item
 */
export const useCreateMitigation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMitigation>>,
    TError,
    { data: BodyType<CreateMitigationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMitigation>>,
  TError,
  { data: BodyType<CreateMitigationBody> },
  TContext
> => {
  return useMutation(getCreateMitigationMutationOptions(options));
};

/**
 * @summary Get a single mitigation item
 */
export const getGetMitigationUrl = (id: number) => {
  return `/api/mitigations/${id}`;
};

export const getMitigation = async (
  id: number,
  options?: RequestInit,
): Promise<Mitigation> => {
  return customFetch<Mitigation>(getGetMitigationUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetMitigationQueryKey = (id: number) => {
  return [`/api/mitigations/${id}`] as const;
};

export const getGetMitigationQueryOptions = <
  TData = Awaited<ReturnType<typeof getMitigation>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMitigation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMitigationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMitigation>>> = ({
    signal,
  }) => getMitigation(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMitigation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMitigationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMitigation>>
>;
export type GetMitigationQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a single mitigation item
 */

export function useGetMitigation<
  TData = Awaited<ReturnType<typeof getMitigation>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMitigation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMitigationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a mitigation item
 */
export const getUpdateMitigationUrl = (id: number) => {
  return `/api/mitigations/${id}`;
};

export const updateMitigation = async (
  id: number,
  updateMitigationBody: UpdateMitigationBody,
  options?: RequestInit,
): Promise<Mitigation> => {
  return customFetch<Mitigation>(getUpdateMitigationUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMitigationBody),
  });
};

export const getUpdateMitigationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMitigation>>,
    TError,
    { id: number; data: BodyType<UpdateMitigationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMitigation>>,
  TError,
  { id: number; data: BodyType<UpdateMitigationBody> },
  TContext
> => {
  const mutationKey = ["updateMitigation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMitigation>>,
    { id: number; data: BodyType<UpdateMitigationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMitigation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMitigationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMitigation>>
>;
export type UpdateMitigationMutationBody = BodyType<UpdateMitigationBody>;
export type UpdateMitigationMutationError = ErrorType<unknown>;

/**
 * @summary Update a mitigation item
 */
export const useUpdateMitigation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMitigation>>,
    TError,
    { id: number; data: BodyType<UpdateMitigationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMitigation>>,
  TError,
  { id: number; data: BodyType<UpdateMitigationBody> },
  TContext
> => {
  return useMutation(getUpdateMitigationMutationOptions(options));
};

/**
 * @summary Delete a mitigation item
 */
export const getDeleteMitigationUrl = (id: number) => {
  return `/api/mitigations/${id}`;
};

export const deleteMitigation = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMitigationUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMitigationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMitigation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMitigation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMitigation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMitigation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMitigation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMitigationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMitigation>>
>;

export type DeleteMitigationMutationError = ErrorType<unknown>;

/**
 * @summary Delete a mitigation item
 */
export const useDeleteMitigation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMitigation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMitigation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteMitigationMutationOptions(options));
};

/**
 * @summary List coaches in a single org (owner-admin)
 */
export const getAdminListOrgCoachesUrl = (id: number) => {
  return `/api/admin/orgs/${id}/coaches`;
};

export const adminListOrgCoaches = async (
  id: number,
  options?: RequestInit,
): Promise<AdminCoachListResponse> => {
  return customFetch<AdminCoachListResponse>(getAdminListOrgCoachesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getAdminListOrgCoachesQueryKey = (id: number) => {
  return [`/api/admin/orgs/${id}/coaches`] as const;
};

export const getAdminListOrgCoachesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListOrgCoaches>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListOrgCoaches>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListOrgCoachesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListOrgCoaches>>
  > = ({ signal }) => adminListOrgCoaches(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListOrgCoaches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListOrgCoachesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListOrgCoaches>>
>;
export type AdminListOrgCoachesQueryError = ErrorType<unknown>;

/**
 * @summary List coaches in a single org (owner-admin)
 */

export function useAdminListOrgCoaches<
  TData = Awaited<ReturnType<typeof adminListOrgCoaches>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListOrgCoaches>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListOrgCoachesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get one coach with insurance + comments (owner-admin)
 */
export const getAdminGetOrgCoachUrl = (id: number, coachId: number) => {
  return `/api/admin/orgs/${id}/coaches/${coachId}`;
};

export const adminGetOrgCoach = async (
  id: number,
  coachId: number,
  options?: RequestInit,
): Promise<AdminCoachDetail> => {
  return customFetch<AdminCoachDetail>(getAdminGetOrgCoachUrl(id, coachId), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetOrgCoachQueryKey = (id: number, coachId: number) => {
  return [`/api/admin/orgs/${id}/coaches/${coachId}`] as const;
};

export const getAdminGetOrgCoachQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetOrgCoach>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  coachId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetOrgCoach>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetOrgCoachQueryKey(id, coachId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetOrgCoach>>
  > = ({ signal }) =>
    adminGetOrgCoach(id, coachId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && coachId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetOrgCoach>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetOrgCoachQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetOrgCoach>>
>;
export type AdminGetOrgCoachQueryError = ErrorType<unknown>;

/**
 * @summary Get one coach with insurance + comments (owner-admin)
 */

export function useAdminGetOrgCoach<
  TData = Awaited<ReturnType<typeof adminGetOrgCoach>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  coachId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetOrgCoach>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetOrgCoachQueryOptions(id, coachId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get full contract detail incl. clause bodies, rounds, files (owner-admin)
 */
export const getAdminGetOrgContractUrl = (id: number, contractId: number) => {
  return `/api/admin/orgs/${id}/contracts/${contractId}`;
};

export const adminGetOrgContract = async (
  id: number,
  contractId: number,
  options?: RequestInit,
): Promise<AdminContractDetail> => {
  return customFetch<AdminContractDetail>(
    getAdminGetOrgContractUrl(id, contractId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetOrgContractQueryKey = (
  id: number,
  contractId: number,
) => {
  return [`/api/admin/orgs/${id}/contracts/${contractId}`] as const;
};

export const getAdminGetOrgContractQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetOrgContract>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetOrgContract>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetOrgContractQueryKey(id, contractId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetOrgContract>>
  > = ({ signal }) =>
    adminGetOrgContract(id, contractId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && contractId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetOrgContract>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetOrgContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetOrgContract>>
>;
export type AdminGetOrgContractQueryError = ErrorType<unknown>;

/**
 * @summary Get full contract detail incl. clause bodies, rounds, files (owner-admin)
 */

export function useAdminGetOrgContract<
  TData = Awaited<ReturnType<typeof adminGetOrgContract>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  contractId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetOrgContract>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetOrgContractQueryOptions(
    id,
    contractId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Stream a contract file (owner-admin)
 */
export const getAdminDownloadOrgFileUrl = (id: number, fileId: number) => {
  return `/api/admin/orgs/${id}/files/${fileId}/download`;
};

export const adminDownloadOrgFile = async (
  id: number,
  fileId: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getAdminDownloadOrgFileUrl(id, fileId), {
    ...options,
    method: "GET",
  });
};

export const getAdminDownloadOrgFileQueryKey = (id: number, fileId: number) => {
  return [`/api/admin/orgs/${id}/files/${fileId}/download`] as const;
};

export const getAdminDownloadOrgFileQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDownloadOrgFile>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  fileId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminDownloadOrgFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminDownloadOrgFileQueryKey(id, fileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminDownloadOrgFile>>
  > = ({ signal }) =>
    adminDownloadOrgFile(id, fileId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && fileId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDownloadOrgFile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminDownloadOrgFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDownloadOrgFile>>
>;
export type AdminDownloadOrgFileQueryError = ErrorType<unknown>;

/**
 * @summary Stream a contract file (owner-admin)
 */

export function useAdminDownloadOrgFile<
  TData = Awaited<ReturnType<typeof adminDownloadOrgFile>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  fileId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminDownloadOrgFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminDownloadOrgFileQueryOptions(id, fileId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Overwrite a member's personas (owner-admin)
 */
export const getAdminSetMemberPersonasUrl = (id: number, memberId: number) => {
  return `/api/admin/orgs/${id}/members/${memberId}/personas`;
};

export const adminSetMemberPersonas = async (
  id: number,
  memberId: number,
  adminPersonasBody: AdminPersonasBody,
  options?: RequestInit,
): Promise<AdminPersonasResponse> => {
  return customFetch<AdminPersonasResponse>(
    getAdminSetMemberPersonasUrl(id, memberId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminPersonasBody),
    },
  );
};

export const getAdminSetMemberPersonasMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetMemberPersonas>>,
    TError,
    { id: number; memberId: number; data: BodyType<AdminPersonasBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetMemberPersonas>>,
  TError,
  { id: number; memberId: number; data: BodyType<AdminPersonasBody> },
  TContext
> => {
  const mutationKey = ["adminSetMemberPersonas"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetMemberPersonas>>,
    { id: number; memberId: number; data: BodyType<AdminPersonasBody> }
  > = (props) => {
    const { id, memberId, data } = props ?? {};

    return adminSetMemberPersonas(id, memberId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetMemberPersonasMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetMemberPersonas>>
>;
export type AdminSetMemberPersonasMutationBody = BodyType<AdminPersonasBody>;
export type AdminSetMemberPersonasMutationError = ErrorType<unknown>;

/**
 * @summary Overwrite a member's personas (owner-admin)
 */
export const useAdminSetMemberPersonas = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetMemberPersonas>>,
    TError,
    { id: number; memberId: number; data: BodyType<AdminPersonasBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetMemberPersonas>>,
  TError,
  { id: number; memberId: number; data: BodyType<AdminPersonasBody> },
  TContext
> => {
  return useMutation(getAdminSetMemberPersonasMutationOptions(options));
};

/**
 * @summary Start read-only impersonation of an org (owner-admin)
 */
export const getAdminStartImpersonationUrl = (id: number) => {
  return `/api/admin/orgs/${id}/impersonate`;
};

export const adminStartImpersonation = async (
  id: number,
  adminImpersonateBody: AdminImpersonateBody,
  options?: RequestInit,
): Promise<AdminImpersonationStatus> => {
  return customFetch<AdminImpersonationStatus>(
    getAdminStartImpersonationUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminImpersonateBody),
    },
  );
};

export const getAdminStartImpersonationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStartImpersonation>>,
    TError,
    { id: number; data: BodyType<AdminImpersonateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStartImpersonation>>,
  TError,
  { id: number; data: BodyType<AdminImpersonateBody> },
  TContext
> => {
  const mutationKey = ["adminStartImpersonation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStartImpersonation>>,
    { id: number; data: BodyType<AdminImpersonateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminStartImpersonation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStartImpersonationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStartImpersonation>>
>;
export type AdminStartImpersonationMutationBody =
  BodyType<AdminImpersonateBody>;
export type AdminStartImpersonationMutationError = ErrorType<unknown>;

/**
 * @summary Start read-only impersonation of an org (owner-admin)
 */
export const useAdminStartImpersonation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStartImpersonation>>,
    TError,
    { id: number; data: BodyType<AdminImpersonateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminStartImpersonation>>,
  TError,
  { id: number; data: BodyType<AdminImpersonateBody> },
  TContext
> => {
  return useMutation(getAdminStartImpersonationMutationOptions(options));
};

/**
 * @summary End the active impersonation session (owner-admin)
 */
export const getAdminStopImpersonationUrl = () => {
  return `/api/admin/impersonate/stop`;
};

export const adminStopImpersonation = async (
  options?: RequestInit,
): Promise<AdminImpersonationStatus> => {
  return customFetch<AdminImpersonationStatus>(getAdminStopImpersonationUrl(), {
    ...options,
    method: "POST",
  });
};

export const getAdminStopImpersonationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStopImpersonation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStopImpersonation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["adminStopImpersonation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStopImpersonation>>,
    void
  > = () => {
    return adminStopImpersonation(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStopImpersonationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStopImpersonation>>
>;

export type AdminStopImpersonationMutationError = ErrorType<unknown>;

/**
 * @summary End the active impersonation session (owner-admin)
 */
export const useAdminStopImpersonation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStopImpersonation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminStopImpersonation>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getAdminStopImpersonationMutationOptions(options));
};

/**
 * @summary List per-org feature flags (owner-admin)
 */
export const getAdminListOrgFeatureFlagsUrl = (id: number) => {
  return `/api/admin/orgs/${id}/feature-flags`;
};

export const adminListOrgFeatureFlags = async (
  id: number,
  options?: RequestInit,
): Promise<AdminFeatureFlagList> => {
  return customFetch<AdminFeatureFlagList>(getAdminListOrgFeatureFlagsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getAdminListOrgFeatureFlagsQueryKey = (id: number) => {
  return [`/api/admin/orgs/${id}/feature-flags`] as const;
};

export const getAdminListOrgFeatureFlagsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListOrgFeatureFlags>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListOrgFeatureFlags>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListOrgFeatureFlagsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListOrgFeatureFlags>>
  > = ({ signal }) =>
    adminListOrgFeatureFlags(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListOrgFeatureFlags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListOrgFeatureFlagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListOrgFeatureFlags>>
>;
export type AdminListOrgFeatureFlagsQueryError = ErrorType<unknown>;

/**
 * @summary List per-org feature flags (owner-admin)
 */

export function useAdminListOrgFeatureFlags<
  TData = Awaited<ReturnType<typeof adminListOrgFeatureFlags>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListOrgFeatureFlags>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListOrgFeatureFlagsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert one per-org feature flag (owner-admin)
 */
export const getAdminUpsertOrgFeatureFlagUrl = (id: number, key: string) => {
  return `/api/admin/orgs/${id}/feature-flags/${key}`;
};

export const adminUpsertOrgFeatureFlag = async (
  id: number,
  key: string,
  adminFeatureFlagBody: AdminFeatureFlagBody,
  options?: RequestInit,
): Promise<AdminFeatureFlag> => {
  return customFetch<AdminFeatureFlag>(
    getAdminUpsertOrgFeatureFlagUrl(id, key),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminFeatureFlagBody),
    },
  );
};

export const getAdminUpsertOrgFeatureFlagMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpsertOrgFeatureFlag>>,
    TError,
    { id: number; key: string; data: BodyType<AdminFeatureFlagBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpsertOrgFeatureFlag>>,
  TError,
  { id: number; key: string; data: BodyType<AdminFeatureFlagBody> },
  TContext
> => {
  const mutationKey = ["adminUpsertOrgFeatureFlag"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpsertOrgFeatureFlag>>,
    { id: number; key: string; data: BodyType<AdminFeatureFlagBody> }
  > = (props) => {
    const { id, key, data } = props ?? {};

    return adminUpsertOrgFeatureFlag(id, key, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpsertOrgFeatureFlagMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpsertOrgFeatureFlag>>
>;
export type AdminUpsertOrgFeatureFlagMutationBody =
  BodyType<AdminFeatureFlagBody>;
export type AdminUpsertOrgFeatureFlagMutationError = ErrorType<unknown>;

/**
 * @summary Upsert one per-org feature flag (owner-admin)
 */
export const useAdminUpsertOrgFeatureFlag = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpsertOrgFeatureFlag>>,
    TError,
    { id: number; key: string; data: BodyType<AdminFeatureFlagBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpsertOrgFeatureFlag>>,
  TError,
  { id: number; key: string; data: BodyType<AdminFeatureFlagBody> },
  TContext
> => {
  return useMutation(getAdminUpsertOrgFeatureFlagMutationOptions(options));
};

/**
 * @summary Set or clear a per-org seat-cap override (owner-admin)
 */
export const getAdminSetOrgSeatCapOverrideUrl = (id: number) => {
  return `/api/admin/orgs/${id}/seat-cap`;
};

export const adminSetOrgSeatCapOverride = async (
  id: number,
  adminSeatCapBody: AdminSeatCapBody,
  options?: RequestInit,
): Promise<AdminSeatCapResponse> => {
  return customFetch<AdminSeatCapResponse>(
    getAdminSetOrgSeatCapOverrideUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminSeatCapBody),
    },
  );
};

export const getAdminSetOrgSeatCapOverrideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetOrgSeatCapOverride>>,
    TError,
    { id: number; data: BodyType<AdminSeatCapBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetOrgSeatCapOverride>>,
  TError,
  { id: number; data: BodyType<AdminSeatCapBody> },
  TContext
> => {
  const mutationKey = ["adminSetOrgSeatCapOverride"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetOrgSeatCapOverride>>,
    { id: number; data: BodyType<AdminSeatCapBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminSetOrgSeatCapOverride(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetOrgSeatCapOverrideMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetOrgSeatCapOverride>>
>;
export type AdminSetOrgSeatCapOverrideMutationBody = BodyType<AdminSeatCapBody>;
export type AdminSetOrgSeatCapOverrideMutationError = ErrorType<unknown>;

/**
 * @summary Set or clear a per-org seat-cap override (owner-admin)
 */
export const useAdminSetOrgSeatCapOverride = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetOrgSeatCapOverride>>,
    TError,
    { id: number; data: BodyType<AdminSeatCapBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetOrgSeatCapOverride>>,
  TError,
  { id: number; data: BodyType<AdminSeatCapBody> },
  TContext
> => {
  return useMutation(getAdminSetOrgSeatCapOverrideMutationOptions(options));
};

/**
 * @summary Owner-only platform health (scheduler runs, webhooks, migrations, impersonations)
 */
export const getAdminGetHealthUrl = () => {
  return `/api/admin/health`;
};

export const adminGetHealth = async (
  options?: RequestInit,
): Promise<AdminHealth> => {
  return customFetch<AdminHealth>(getAdminGetHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetHealthQueryKey = () => {
  return [`/api/admin/health`] as const;
};

export const getAdminGetHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetHealth>>> = ({
    signal,
  }) => adminGetHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetHealth>>
>;
export type AdminGetHealthQueryError = ErrorType<unknown>;

/**
 * @summary Owner-only platform health (scheduler runs, webhooks, migrations, impersonations)
 */

export function useAdminGetHealth<
  TData = Awaited<ReturnType<typeof adminGetHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary MRR, ARR, 30d delta, past-due count, and failed-payment count over the last 24h
 */
export const getAdminGetInsightsRevenueUrl = () => {
  return `/api/admin/insights/revenue`;
};

export const adminGetInsightsRevenue = async (
  options?: RequestInit,
): Promise<AdminInsightsRevenue> => {
  return customFetch<AdminInsightsRevenue>(getAdminGetInsightsRevenueUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetInsightsRevenueQueryKey = () => {
  return [`/api/admin/insights/revenue`] as const;
};

export const getAdminGetInsightsRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetInsightsRevenue>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsRevenue>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetInsightsRevenueQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetInsightsRevenue>>
  > = ({ signal }) => adminGetInsightsRevenue({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetInsightsRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetInsightsRevenue>>
>;
export type AdminGetInsightsRevenueQueryError = ErrorType<unknown>;

/**
 * @summary MRR, ARR, 30d delta, past-due count, and failed-payment count over the last 24h
 */

export function useAdminGetInsightsRevenue<
  TData = Awaited<ReturnType<typeof adminGetInsightsRevenue>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsRevenue>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetInsightsRevenueQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Trial signup funnel (pending→verified→signed up, last 30 days) plus trials ending in the next 7 days
 */
export const getAdminGetInsightsTrialsUrl = () => {
  return `/api/admin/insights/trials`;
};

export const adminGetInsightsTrials = async (
  options?: RequestInit,
): Promise<AdminInsightsTrials> => {
  return customFetch<AdminInsightsTrials>(getAdminGetInsightsTrialsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetInsightsTrialsQueryKey = () => {
  return [`/api/admin/insights/trials`] as const;
};

export const getAdminGetInsightsTrialsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetInsightsTrials>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsTrials>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetInsightsTrialsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetInsightsTrials>>
  > = ({ signal }) => adminGetInsightsTrials({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsTrials>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetInsightsTrialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetInsightsTrials>>
>;
export type AdminGetInsightsTrialsQueryError = ErrorType<unknown>;

/**
 * @summary Trial signup funnel (pending→verified→signed up, last 30 days) plus trials ending in the next 7 days
 */

export function useAdminGetInsightsTrials<
  TData = Awaited<ReturnType<typeof adminGetInsightsTrials>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsTrials>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetInsightsTrialsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Tenants with zero activity in the last 14 days and seat-cap utilization above 80%
 */
export const getAdminGetInsightsAtRiskUrl = () => {
  return `/api/admin/insights/at-risk`;
};

export const adminGetInsightsAtRisk = async (
  options?: RequestInit,
): Promise<AdminInsightsAtRisk> => {
  return customFetch<AdminInsightsAtRisk>(getAdminGetInsightsAtRiskUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetInsightsAtRiskQueryKey = () => {
  return [`/api/admin/insights/at-risk`] as const;
};

export const getAdminGetInsightsAtRiskQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetInsightsAtRisk>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsAtRisk>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetInsightsAtRiskQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetInsightsAtRisk>>
  > = ({ signal }) => adminGetInsightsAtRisk({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsAtRisk>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetInsightsAtRiskQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetInsightsAtRisk>>
>;
export type AdminGetInsightsAtRiskQueryError = ErrorType<unknown>;

/**
 * @summary Tenants with zero activity in the last 14 days and seat-cap utilization above 80%
 */

export function useAdminGetInsightsAtRisk<
  TData = Awaited<ReturnType<typeof adminGetInsightsAtRisk>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsAtRisk>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetInsightsAtRiskQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Cross-tenant contract lifecycle counts and expiring-soon buckets
 */
export const getAdminGetInsightsLifecycleUrl = () => {
  return `/api/admin/insights/lifecycle`;
};

export const adminGetInsightsLifecycle = async (
  options?: RequestInit,
): Promise<AdminInsightsLifecycle> => {
  return customFetch<AdminInsightsLifecycle>(
    getAdminGetInsightsLifecycleUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetInsightsLifecycleQueryKey = () => {
  return [`/api/admin/insights/lifecycle`] as const;
};

export const getAdminGetInsightsLifecycleQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetInsightsLifecycle>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsLifecycle>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetInsightsLifecycleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetInsightsLifecycle>>
  > = ({ signal }) => adminGetInsightsLifecycle({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsLifecycle>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetInsightsLifecycleQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetInsightsLifecycle>>
>;
export type AdminGetInsightsLifecycleQueryError = ErrorType<unknown>;

/**
 * @summary Cross-tenant contract lifecycle counts and expiring-soon buckets
 */

export function useAdminGetInsightsLifecycle<
  TData = Awaited<ReturnType<typeof adminGetInsightsLifecycle>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsLifecycle>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetInsightsLifecycleQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Email/webhook deliverability over the last 24h plus recent negotiation email outcomes
 */
export const getAdminGetInsightsDeliverabilityUrl = () => {
  return `/api/admin/insights/deliverability`;
};

export const adminGetInsightsDeliverability = async (
  options?: RequestInit,
): Promise<AdminInsightsDeliverability> => {
  return customFetch<AdminInsightsDeliverability>(
    getAdminGetInsightsDeliverabilityUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetInsightsDeliverabilityQueryKey = () => {
  return [`/api/admin/insights/deliverability`] as const;
};

export const getAdminGetInsightsDeliverabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetInsightsDeliverability>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsDeliverability>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetInsightsDeliverabilityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetInsightsDeliverability>>
  > = ({ signal }) =>
    adminGetInsightsDeliverability({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsDeliverability>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetInsightsDeliverabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetInsightsDeliverability>>
>;
export type AdminGetInsightsDeliverabilityQueryError = ErrorType<unknown>;

/**
 * @summary Email/webhook deliverability over the last 24h plus recent negotiation email outcomes
 */

export function useAdminGetInsightsDeliverability<
  TData = Awaited<ReturnType<typeof adminGetInsightsDeliverability>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInsightsDeliverability>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetInsightsDeliverabilityQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Redeem an owner-issued demo invitation token, set the demo-tier cookie, and mint a Clerk sign-in token
 */
export const getDemoInviteRedeemUrl = () => {
  return `/api/demo/invite/redeem`;
};

export const demoInviteRedeem = async (
  demoInviteRedeemRequest: DemoInviteRedeemRequest,
  options?: RequestInit,
): Promise<DemoInviteRedeemResponse> => {
  return customFetch<DemoInviteRedeemResponse>(getDemoInviteRedeemUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(demoInviteRedeemRequest),
  });
};

export const getDemoInviteRedeemMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof demoInviteRedeem>>,
    TError,
    { data: BodyType<DemoInviteRedeemRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof demoInviteRedeem>>,
  TError,
  { data: BodyType<DemoInviteRedeemRequest> },
  TContext
> => {
  const mutationKey = ["demoInviteRedeem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof demoInviteRedeem>>,
    { data: BodyType<DemoInviteRedeemRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return demoInviteRedeem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DemoInviteRedeemMutationResult = NonNullable<
  Awaited<ReturnType<typeof demoInviteRedeem>>
>;
export type DemoInviteRedeemMutationBody = BodyType<DemoInviteRedeemRequest>;
export type DemoInviteRedeemMutationError = ErrorType<void>;

/**
 * @summary Redeem an owner-issued demo invitation token, set the demo-tier cookie, and mint a Clerk sign-in token
 */
export const useDemoInviteRedeem = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof demoInviteRedeem>>,
    TError,
    { data: BodyType<DemoInviteRedeemRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof demoInviteRedeem>>,
  TError,
  { data: BodyType<DemoInviteRedeemRequest> },
  TContext
> => {
  return useMutation(getDemoInviteRedeemMutationOptions(options));
};

/**
 * @summary List custom field definitions for the org
 */
export const getListCustomFieldDefinitionsUrl = (
  params?: ListCustomFieldDefinitionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/custom-fields/definitions?${stringifiedParams}`
    : `/api/custom-fields/definitions`;
};

export const listCustomFieldDefinitions = async (
  params?: ListCustomFieldDefinitionsParams,
  options?: RequestInit,
): Promise<CustomFieldDefinition[]> => {
  return customFetch<CustomFieldDefinition[]>(
    getListCustomFieldDefinitionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCustomFieldDefinitionsQueryKey = (
  params?: ListCustomFieldDefinitionsParams,
) => {
  return [
    `/api/custom-fields/definitions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListCustomFieldDefinitionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomFieldDefinitions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomFieldDefinitionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomFieldDefinitions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCustomFieldDefinitionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCustomFieldDefinitions>>
  > = ({ signal }) =>
    listCustomFieldDefinitions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomFieldDefinitions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomFieldDefinitionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomFieldDefinitions>>
>;
export type ListCustomFieldDefinitionsQueryError = ErrorType<unknown>;

/**
 * @summary List custom field definitions for the org
 */

export function useListCustomFieldDefinitions<
  TData = Awaited<ReturnType<typeof listCustomFieldDefinitions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomFieldDefinitionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomFieldDefinitions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomFieldDefinitionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a custom field definition (admin only)
 */
export const getCreateCustomFieldDefinitionUrl = () => {
  return `/api/custom-fields/definitions`;
};

export const createCustomFieldDefinition = async (
  createCustomFieldDefinitionBody: CreateCustomFieldDefinitionBody,
  options?: RequestInit,
): Promise<CustomFieldDefinition> => {
  return customFetch<CustomFieldDefinition>(
    getCreateCustomFieldDefinitionUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createCustomFieldDefinitionBody),
    },
  );
};

export const getCreateCustomFieldDefinitionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomFieldDefinition>>,
    TError,
    { data: BodyType<CreateCustomFieldDefinitionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomFieldDefinition>>,
  TError,
  { data: BodyType<CreateCustomFieldDefinitionBody> },
  TContext
> => {
  const mutationKey = ["createCustomFieldDefinition"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomFieldDefinition>>,
    { data: BodyType<CreateCustomFieldDefinitionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCustomFieldDefinition(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomFieldDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomFieldDefinition>>
>;
export type CreateCustomFieldDefinitionMutationBody =
  BodyType<CreateCustomFieldDefinitionBody>;
export type CreateCustomFieldDefinitionMutationError = ErrorType<unknown>;

/**
 * @summary Create a custom field definition (admin only)
 */
export const useCreateCustomFieldDefinition = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomFieldDefinition>>,
    TError,
    { data: BodyType<CreateCustomFieldDefinitionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCustomFieldDefinition>>,
  TError,
  { data: BodyType<CreateCustomFieldDefinitionBody> },
  TContext
> => {
  return useMutation(getCreateCustomFieldDefinitionMutationOptions(options));
};

/**
 * @summary Update a custom field definition (admin only)
 */
export const getUpdateCustomFieldDefinitionUrl = (id: number) => {
  return `/api/custom-fields/definitions/${id}`;
};

export const updateCustomFieldDefinition = async (
  id: number,
  updateCustomFieldDefinitionBody: UpdateCustomFieldDefinitionBody,
  options?: RequestInit,
): Promise<CustomFieldDefinition> => {
  return customFetch<CustomFieldDefinition>(
    getUpdateCustomFieldDefinitionUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateCustomFieldDefinitionBody),
    },
  );
};

export const getUpdateCustomFieldDefinitionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomFieldDefinition>>,
    TError,
    { id: number; data: BodyType<UpdateCustomFieldDefinitionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCustomFieldDefinition>>,
  TError,
  { id: number; data: BodyType<UpdateCustomFieldDefinitionBody> },
  TContext
> => {
  const mutationKey = ["updateCustomFieldDefinition"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCustomFieldDefinition>>,
    { id: number; data: BodyType<UpdateCustomFieldDefinitionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCustomFieldDefinition(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCustomFieldDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomFieldDefinition>>
>;
export type UpdateCustomFieldDefinitionMutationBody =
  BodyType<UpdateCustomFieldDefinitionBody>;
export type UpdateCustomFieldDefinitionMutationError = ErrorType<unknown>;

/**
 * @summary Update a custom field definition (admin only)
 */
export const useUpdateCustomFieldDefinition = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomFieldDefinition>>,
    TError,
    { id: number; data: BodyType<UpdateCustomFieldDefinitionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCustomFieldDefinition>>,
  TError,
  { id: number; data: BodyType<UpdateCustomFieldDefinitionBody> },
  TContext
> => {
  return useMutation(getUpdateCustomFieldDefinitionMutationOptions(options));
};

/**
 * @summary Delete a custom field definition (admin only)
 */
export const getDeleteCustomFieldDefinitionUrl = (id: number) => {
  return `/api/custom-fields/definitions/${id}`;
};

export const deleteCustomFieldDefinition = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCustomFieldDefinitionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCustomFieldDefinitionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomFieldDefinition>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomFieldDefinition>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCustomFieldDefinition"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomFieldDefinition>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCustomFieldDefinition(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomFieldDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomFieldDefinition>>
>;

export type DeleteCustomFieldDefinitionMutationError = ErrorType<unknown>;

/**
 * @summary Delete a custom field definition (admin only)
 */
export const useDeleteCustomFieldDefinition = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomFieldDefinition>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomFieldDefinition>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCustomFieldDefinitionMutationOptions(options));
};

/**
 * @summary Get custom field values for a specific entity
 */
export const getListCustomFieldValuesUrl = (
  params: ListCustomFieldValuesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/custom-fields/values?${stringifiedParams}`
    : `/api/custom-fields/values`;
};

export const listCustomFieldValues = async (
  params: ListCustomFieldValuesParams,
  options?: RequestInit,
): Promise<CustomFieldEntityValue[]> => {
  return customFetch<CustomFieldEntityValue[]>(
    getListCustomFieldValuesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCustomFieldValuesQueryKey = (
  params?: ListCustomFieldValuesParams,
) => {
  return [`/api/custom-fields/values`, ...(params ? [params] : [])] as const;
};

export const getListCustomFieldValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomFieldValues>>,
  TError = ErrorType<unknown>,
>(
  params: ListCustomFieldValuesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomFieldValues>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCustomFieldValuesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCustomFieldValues>>
  > = ({ signal }) =>
    listCustomFieldValues(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomFieldValues>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomFieldValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomFieldValues>>
>;
export type ListCustomFieldValuesQueryError = ErrorType<unknown>;

/**
 * @summary Get custom field values for a specific entity
 */

export function useListCustomFieldValues<
  TData = Awaited<ReturnType<typeof listCustomFieldValues>>,
  TError = ErrorType<unknown>,
>(
  params: ListCustomFieldValuesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomFieldValues>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomFieldValuesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save custom field values for an entity (batch upsert)
 */
export const getUpsertCustomFieldValuesUrl = () => {
  return `/api/custom-fields/values`;
};

export const upsertCustomFieldValues = async (
  upsertCustomFieldValuesBody: UpsertCustomFieldValuesBody,
  options?: RequestInit,
): Promise<UpsertCustomFieldValues200> => {
  return customFetch<UpsertCustomFieldValues200>(
    getUpsertCustomFieldValuesUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(upsertCustomFieldValuesBody),
    },
  );
};

export const getUpsertCustomFieldValuesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertCustomFieldValues>>,
    TError,
    { data: BodyType<UpsertCustomFieldValuesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertCustomFieldValues>>,
  TError,
  { data: BodyType<UpsertCustomFieldValuesBody> },
  TContext
> => {
  const mutationKey = ["upsertCustomFieldValues"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertCustomFieldValues>>,
    { data: BodyType<UpsertCustomFieldValuesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return upsertCustomFieldValues(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertCustomFieldValuesMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertCustomFieldValues>>
>;
export type UpsertCustomFieldValuesMutationBody =
  BodyType<UpsertCustomFieldValuesBody>;
export type UpsertCustomFieldValuesMutationError = ErrorType<unknown>;

/**
 * @summary Save custom field values for an entity (batch upsert)
 */
export const useUpsertCustomFieldValues = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertCustomFieldValues>>,
    TError,
    { data: BodyType<UpsertCustomFieldValuesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertCustomFieldValues>>,
  TError,
  { data: BodyType<UpsertCustomFieldValuesBody> },
  TContext
> => {
  return useMutation(getUpsertCustomFieldValuesMutationOptions(options));
};

/**
 * @summary List all owner-issued demo invitations with usage attribution
 */
export const getAdminListDemoInvitationsUrl = () => {
  return `/api/admin/demo/invitations`;
};

export const adminListDemoInvitations = async (
  options?: RequestInit,
): Promise<AdminDemoInvitation[]> => {
  return customFetch<AdminDemoInvitation[]>(getAdminListDemoInvitationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListDemoInvitationsQueryKey = () => {
  return [`/api/admin/demo/invitations`] as const;
};

export const getAdminListDemoInvitationsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDemoInvitations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListDemoInvitations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListDemoInvitationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListDemoInvitations>>
  > = ({ signal }) => adminListDemoInvitations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDemoInvitations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListDemoInvitationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDemoInvitations>>
>;
export type AdminListDemoInvitationsQueryError = ErrorType<unknown>;

/**
 * @summary List all owner-issued demo invitations with usage attribution
 */

export function useAdminListDemoInvitations<
  TData = Awaited<ReturnType<typeof adminListDemoInvitations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListDemoInvitations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListDemoInvitationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mint a tailored demo invitation (tier + persona + fixed expiry)
 */
export const getAdminCreateDemoInvitationUrl = () => {
  return `/api/admin/demo/invitations`;
};

export const adminCreateDemoInvitation = async (
  adminDemoInvitationCreateRequest: AdminDemoInvitationCreateRequest,
  options?: RequestInit,
): Promise<AdminDemoInvitation> => {
  return customFetch<AdminDemoInvitation>(getAdminCreateDemoInvitationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminDemoInvitationCreateRequest),
  });
};

export const getAdminCreateDemoInvitationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateDemoInvitation>>,
    TError,
    { data: BodyType<AdminDemoInvitationCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateDemoInvitation>>,
  TError,
  { data: BodyType<AdminDemoInvitationCreateRequest> },
  TContext
> => {
  const mutationKey = ["adminCreateDemoInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateDemoInvitation>>,
    { data: BodyType<AdminDemoInvitationCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateDemoInvitation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateDemoInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateDemoInvitation>>
>;
export type AdminCreateDemoInvitationMutationBody =
  BodyType<AdminDemoInvitationCreateRequest>;
export type AdminCreateDemoInvitationMutationError = ErrorType<unknown>;

/**
 * @summary Mint a tailored demo invitation (tier + persona + fixed expiry)
 */
export const useAdminCreateDemoInvitation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateDemoInvitation>>,
    TError,
    { data: BodyType<AdminDemoInvitationCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateDemoInvitation>>,
  TError,
  { data: BodyType<AdminDemoInvitationCreateRequest> },
  TContext
> => {
  return useMutation(getAdminCreateDemoInvitationMutationOptions(options));
};

/**
 * @summary Revoke an outstanding demo invitation
 */
export const getAdminRevokeDemoInvitationUrl = (id: number) => {
  return `/api/admin/demo/invitations/${id}`;
};

export const adminRevokeDemoInvitation = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getAdminRevokeDemoInvitationUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminRevokeDemoInvitationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRevokeDemoInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRevokeDemoInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["adminRevokeDemoInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRevokeDemoInvitation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return adminRevokeDemoInvitation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRevokeDemoInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRevokeDemoInvitation>>
>;

export type AdminRevokeDemoInvitationMutationError = ErrorType<unknown>;

/**
 * @summary Revoke an outstanding demo invitation
 */
export const useAdminRevokeDemoInvitation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRevokeDemoInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminRevokeDemoInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAdminRevokeDemoInvitationMutationOptions(options));
};

/**
 * @summary Get structured compensation for a contract
 */
export const getGetContractCompensationUrl = (id: number) => {
  return `/api/contracts/${id}/compensation`;
};

export const getContractCompensation = async (
  id: number,
  options?: RequestInit,
): Promise<ContractCompensation> => {
  return customFetch<ContractCompensation>(getGetContractCompensationUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContractCompensationQueryKey = (id: number) => {
  return [`/api/contracts/${id}/compensation`] as const;
};

export const getGetContractCompensationQueryOptions = <
  TData = Awaited<ReturnType<typeof getContractCompensation>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContractCompensation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetContractCompensationQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContractCompensation>>
  > = ({ signal }) =>
    getContractCompensation(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContractCompensation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContractCompensationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContractCompensation>>
>;
export type GetContractCompensationQueryError = ErrorType<void>;

/**
 * @summary Get structured compensation for a contract
 */

export function useGetContractCompensation<
  TData = Awaited<ReturnType<typeof getContractCompensation>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContractCompensation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContractCompensationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Patch one or more compensation fields (admin or Finance persona)
 */
export const getUpdateContractCompensationUrl = (id: number) => {
  return `/api/contracts/${id}/compensation`;
};

export const updateContractCompensation = async (
  id: number,
  updateContractCompensationBody: UpdateContractCompensationBody,
  options?: RequestInit,
): Promise<ContractCompensation> => {
  return customFetch<ContractCompensation>(
    getUpdateContractCompensationUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateContractCompensationBody),
    },
  );
};

export const getUpdateContractCompensationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContractCompensation>>,
    TError,
    { id: number; data: BodyType<UpdateContractCompensationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContractCompensation>>,
  TError,
  { id: number; data: BodyType<UpdateContractCompensationBody> },
  TContext
> => {
  const mutationKey = ["updateContractCompensation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContractCompensation>>,
    { id: number; data: BodyType<UpdateContractCompensationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateContractCompensation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateContractCompensationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateContractCompensation>>
>;
export type UpdateContractCompensationMutationBody =
  BodyType<UpdateContractCompensationBody>;
export type UpdateContractCompensationMutationError = ErrorType<void>;

/**
 * @summary Patch one or more compensation fields (admin or Finance persona)
 */
export const useUpdateContractCompensation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContractCompensation>>,
    TError,
    { id: number; data: BodyType<UpdateContractCompensationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateContractCompensation>>,
  TError,
  { id: number; data: BodyType<UpdateContractCompensationBody> },
  TContext
> => {
  return useMutation(getUpdateContractCompensationMutationOptions(options));
};

/**
 * @summary Re-run extractor for a single contract (admin)
 */
export const getBackfillContractCompensationUrl = (id: number) => {
  return `/api/contracts/${id}/compensation/backfill`;
};

export const backfillContractCompensation = async (
  id: number,
  options?: RequestInit,
): Promise<BackfillContractCompensation200> => {
  return customFetch<BackfillContractCompensation200>(
    getBackfillContractCompensationUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getBackfillContractCompensationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillContractCompensation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backfillContractCompensation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["backfillContractCompensation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backfillContractCompensation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return backfillContractCompensation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackfillContractCompensationMutationResult = NonNullable<
  Awaited<ReturnType<typeof backfillContractCompensation>>
>;

export type BackfillContractCompensationMutationError = ErrorType<void>;

/**
 * @summary Re-run extractor for a single contract (admin)
 */
export const useBackfillContractCompensation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillContractCompensation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof backfillContractCompensation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getBackfillContractCompensationMutationOptions(options));
};

/**
 * @summary Run extractor across every contract in the org (admin)
 */
export const getBackfillAllCompensationUrl = () => {
  return `/api/compensation/backfill-all`;
};

export const backfillAllCompensation = async (
  options?: RequestInit,
): Promise<CompensationBackfillAllResponse> => {
  return customFetch<CompensationBackfillAllResponse>(
    getBackfillAllCompensationUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getBackfillAllCompensationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillAllCompensation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backfillAllCompensation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["backfillAllCompensation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backfillAllCompensation>>,
    void
  > = () => {
    return backfillAllCompensation(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackfillAllCompensationMutationResult = NonNullable<
  Awaited<ReturnType<typeof backfillAllCompensation>>
>;

export type BackfillAllCompensationMutationError = ErrorType<unknown>;

/**
 * @summary Run extractor across every contract in the org (admin)
 */
export const useBackfillAllCompensation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillAllCompensation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof backfillAllCompensation>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getBackfillAllCompensationMutationOptions(options));
};

/**
 * @summary List contracts with at least one proposed-status comp field
 */
export const getListCompensationNeedsReviewUrl = (
  params?: ListCompensationNeedsReviewParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/compensation/needs-review?${stringifiedParams}`
    : `/api/compensation/needs-review`;
};

export const listCompensationNeedsReview = async (
  params?: ListCompensationNeedsReviewParams,
  options?: RequestInit,
): Promise<CompensationNeedsReviewResponse> => {
  return customFetch<CompensationNeedsReviewResponse>(
    getListCompensationNeedsReviewUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCompensationNeedsReviewQueryKey = (
  params?: ListCompensationNeedsReviewParams,
) => {
  return [
    `/api/compensation/needs-review`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListCompensationNeedsReviewQueryOptions = <
  TData = Awaited<ReturnType<typeof listCompensationNeedsReview>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCompensationNeedsReviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCompensationNeedsReview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCompensationNeedsReviewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCompensationNeedsReview>>
  > = ({ signal }) =>
    listCompensationNeedsReview(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCompensationNeedsReview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCompensationNeedsReviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCompensationNeedsReview>>
>;
export type ListCompensationNeedsReviewQueryError = ErrorType<unknown>;

/**
 * @summary List contracts with at least one proposed-status comp field
 */

export function useListCompensationNeedsReview<
  TData = Awaited<ReturnType<typeof listCompensationNeedsReview>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCompensationNeedsReviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCompensationNeedsReview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCompensationNeedsReviewQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Promote every `proposed` compensation field in the org to `confirmed`
 */
export const getBulkConfirmCompensationUrl = () => {
  return `/api/compensation/bulk-confirm`;
};

export const bulkConfirmCompensation = async (
  options?: RequestInit,
): Promise<BulkConfirmCompensation200> => {
  return customFetch<BulkConfirmCompensation200>(
    getBulkConfirmCompensationUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getBulkConfirmCompensationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkConfirmCompensation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkConfirmCompensation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["bulkConfirmCompensation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkConfirmCompensation>>,
    void
  > = () => {
    return bulkConfirmCompensation(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkConfirmCompensationMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkConfirmCompensation>>
>;

export type BulkConfirmCompensationMutationError = ErrorType<void>;

/**
 * @summary Promote every `proposed` compensation field in the org to `confirmed`
 */
export const useBulkConfirmCompensation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkConfirmCompensation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkConfirmCompensation>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getBulkConfirmCompensationMutationOptions(options));
};

/**
 * @summary Per-sport coverage diagnostics (verification rollup)
 */
export const getGetCompensationCoverageUrl = () => {
  return `/api/compensation/coverage`;
};

export const getCompensationCoverage = async (
  options?: RequestInit,
): Promise<CompensationCoverageResponse> => {
  return customFetch<CompensationCoverageResponse>(
    getGetCompensationCoverageUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCompensationCoverageQueryKey = () => {
  return [`/api/compensation/coverage`] as const;
};

export const getGetCompensationCoverageQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompensationCoverage>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCompensationCoverage>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCompensationCoverageQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCompensationCoverage>>
  > = ({ signal }) => getCompensationCoverage({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompensationCoverage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompensationCoverageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompensationCoverage>>
>;
export type GetCompensationCoverageQueryError = ErrorType<unknown>;

/**
 * @summary Per-sport coverage diagnostics (verification rollup)
 */

export function useGetCompensationCoverage<
  TData = Awaited<ReturnType<typeof getCompensationCoverage>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCompensationCoverage>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCompensationCoverageQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Read the org's fiscal year start month (1-12)
 */
export const getGetOrgFiscalYearUrl = () => {
  return `/api/org/fiscal-year`;
};

export const getOrgFiscalYear = async (
  options?: RequestInit,
): Promise<OrgFiscalYearResponse> => {
  return customFetch<OrgFiscalYearResponse>(getGetOrgFiscalYearUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOrgFiscalYearQueryKey = () => {
  return [`/api/org/fiscal-year`] as const;
};

export const getGetOrgFiscalYearQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrgFiscalYear>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrgFiscalYear>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrgFiscalYearQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrgFiscalYear>>
  > = ({ signal }) => getOrgFiscalYear({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrgFiscalYear>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrgFiscalYearQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrgFiscalYear>>
>;
export type GetOrgFiscalYearQueryError = ErrorType<unknown>;

/**
 * @summary Read the org's fiscal year start month (1-12)
 */

export function useGetOrgFiscalYear<
  TData = Awaited<ReturnType<typeof getOrgFiscalYear>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrgFiscalYear>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrgFiscalYearQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the org's fiscal year start month (admin)
 */
export const getUpdateOrgFiscalYearUrl = () => {
  return `/api/org/fiscal-year`;
};

export const updateOrgFiscalYear = async (
  updateOrgFiscalYearBody: UpdateOrgFiscalYearBody,
  options?: RequestInit,
): Promise<OrgFiscalYearResponse> => {
  return customFetch<OrgFiscalYearResponse>(getUpdateOrgFiscalYearUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateOrgFiscalYearBody),
  });
};

export const getUpdateOrgFiscalYearMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrgFiscalYear>>,
    TError,
    { data: BodyType<UpdateOrgFiscalYearBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrgFiscalYear>>,
  TError,
  { data: BodyType<UpdateOrgFiscalYearBody> },
  TContext
> => {
  const mutationKey = ["updateOrgFiscalYear"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrgFiscalYear>>,
    { data: BodyType<UpdateOrgFiscalYearBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateOrgFiscalYear(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrgFiscalYearMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrgFiscalYear>>
>;
export type UpdateOrgFiscalYearMutationBody = BodyType<UpdateOrgFiscalYearBody>;
export type UpdateOrgFiscalYearMutationError = ErrorType<void>;

/**
 * @summary Update the org's fiscal year start month (admin)
 */
export const useUpdateOrgFiscalYear = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrgFiscalYear>>,
    TError,
    { data: BodyType<UpdateOrgFiscalYearBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrgFiscalYear>>,
  TError,
  { data: BodyType<UpdateOrgFiscalYearBody> },
  TContext
> => {
  return useMutation(getUpdateOrgFiscalYearMutationOptions(options));
};
